<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <el-row type="flex" justify="space-between">
      <div class="info-filter">
        <span v-if="packsReceiptsFilter.period.enabled">
          {{ $t("common.filter.info.periodWith") }}
          {{ packsReceiptsFilter.period.dateBegin }}
          {{ $t("common.filter.info.periodTo") }}
          {{ packsReceiptsFilter.period.dateEnd }}
        </span>
        <span v-if="packsReceiptsFilter.organization.enabled"
          >{{ $t("common.filter.info.organization") }} -
          {{ organizationName }}</span
        >
        <span v-if="packsReceiptsFilter.payment.enabled"
          >{{ $t("common.filter.info.payment") }} - {{ paymentName }}</span
        >
        <span v-if="packsReceiptsFilter.sum.enabled">
          {{ $t("common.filter.info.sumMin") }}
          {{ packsReceiptsFilter.sum.sumBegin }}
          {{ params.goptions.monetary_unit }},
          {{ $t("common.filter.info.sumMax") }}
          {{ packsReceiptsFilter.sum.sumEnd }}
          {{ params.goptions.monetary_unit }}
        </span>
        <span v-if="packsReceiptsFilter.showSpaced.enabled">{{
          $t("common.filter.info.showSpaced")
        }}</span>
      </div>
      <el-button
        :type="filterType"
        size="small"
        @click="filterModal = true"
        v-shortkey="{ F7: ['f7'] }"
        @shortkey.native="onShortKeyRouter"
        ><span class="key-name">F7</span
        >{{ $t("common.buttons.filter") }}</el-button
      >
    </el-row>
    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container-full">
        <ag-grid-vue
          style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
          class="ag-theme-balham"
          :columnDefs="packsReceiptsColumnDefs"
          :rowData="packsReceipts"
          :defaultColDef="defaultColDef"
          :gridOptions="packsReceiptsGridOptions"
          :getRowStyle="getRowStyle"
          :pinnedBottomRowData="packsReceiptsPinnedBottomRowData"
          :modules="agGridModules"
          rowSelection="single"
          @grid-ready="onPacksReceiptsGridReady"
          @first-data-rendered="onPacksReceiptsFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @modelUpdated="onPacksReceiptsModelUpdated"
          @rowSelected="onPacksReceiptsRowSelected"
          @cellContextMenu="onPacksReceiptsRowRightClicked"
        ></ag-grid-vue>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between" style="margin-top: 10px">
      <el-col :span="24">
        <el-button-group style="margin-right: 20px; margin-top: -1px;">
          <el-button
            type="primary"
            size="small"
            :disabled="addBtnDisabled"
            @click="onAddBtn"
            v-shortkey="{ Insert: ['insert'], Plus: ['+'] }"
            @shortkey.native="onShortKeyRouter"
            ><span class="key-name">Ins</span
            >{{ $t("common.buttons.add") }}</el-button
          >
          <el-button
            type="primary"
            size="small"
            :disabled="editBtnDisabled"
            @click="onEditBtn"
            v-shortkey="{ Enter: ['enter'], F4: ['f4'], Star: ['*'] }"
            @shortkey.native="onShortKeyRouter"
            ><span class="key-name">F4</span
            >{{ $t("common.buttons.edit") }}</el-button
          >
          <el-button
            type="primary"
            size="small"
            :disabled="deleteBtnDisabled"
            @click="onDeleteBtn"
            v-shortkey="{ Del: ['del'], Minus: ['-'] }"
            @shortkey.native="onShortKeyRouter"
            ><span class="key-name">Del</span
            >{{ $t("common.buttons.delete") }}</el-button
          >
          <el-button
            v-if="false"
            type="primary"
            size="small"
            class="buttons-panel"
            :disabled="postingBtnDisabled"
            @click="onPostingBtn"
            v-shortkey="{ F9: ['f9'] }"
            @shortkey.native="onShortKeyRouter"
            ><span class="key-name">F9</span
            >{{ $t("common.buttons.posting") }}</el-button
          >
        </el-button-group>

        <el-dropdown trigger="click">
          <el-button
            type="primary"
            size="small"
            class="buttons-panel"
            :disabled="importBtnDisabled"
          >
            {{ $t("common.buttons.importDots.import") }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-if="params.importpack.importpackpay === '1'"
              @click.native="onImportPaymentsBtn"
              v-shortkey="{ F8: ['f8'] }"
              @shortkey.native="onShortKeyRouter"
              >{{ $t("common.buttons.importDots.payments")
              }}<span class="hot-keys-pay">F8</span></el-dropdown-item
            >
            <el-dropdown-item
              v-if="params.importpack.importpacksubs === '1'"
              @click.native="onImportSubsidiesBtn"
              v-shortkey="{ ShiftF8: ['shift', 'f8'] }"
              @shortkey.native="onShortKeyRouter"
              >{{ $t("common.buttons.importDots.subsidies")
              }}<span class="hot-keys-sub">Shift + F8</span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <el-button
          type="primary"
          size="small"
          class="buttons-panel"
          :disabled="deletePacksBtnDisabled"
          @click="onDeletedPacksBtn"
          >{{ $t("common.buttons.deletePacks") }}</el-button
        >

        <el-dropdown trigger="click">
          <el-button
            type="primary"
            size="small"
            class="buttons-panel"
            :disabled="extraBtnDisabled"
          >
            {{ $t("common.buttons.extraDots.extra") }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="onIndefiniteReceiptsBtn">{{
              $t("common.buttons.extraDots.indefinite")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('common.filter.modal.title')"
      :visible.sync="filterModal"
      :close-on-click-modal="false"
      @open="filterModalShow"
      @close="filterModalHide"
      :width="dialogWidth"
      class="resize"
      center
      v-draggable
    >
      <el-form :model="filterForm" :rules="filterRules" ref="filterForm">
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="filterForm.dateEnabled"
                disabled
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.dateRange.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div style="text-align: center">
                {{ $t("common.filter.form.dateRange.from") }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="dateRange">
              <el-date-picker
                v-model="filterForm.dateRange"
                type="daterange"
                :start-placeholder="$t('common.filter.form.dateRange.start')"
                :end-placeholder="$t('common.filter.form.dateRange.end')"
                :range-separator="$t('common.filter.form.dateRange.separator')"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                unlink-panels
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="filterForm.organizationEnabled"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.organization.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>&nbsp;</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="organizationCode">
              <el-select
                v-model="filterForm.organizationCode"
                :placeholder="$t('common.components.select.placeholder')"
                clearable
                filterable
                :disabled="!filterForm.organizationEnabled"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in params.gfirme.data"
                  :key="item.codefirme"
                  :label="item.namefirme"
                  :value="item.codefirme"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox v-model="filterForm.paymentEnabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.payment.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>&nbsp;</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="paymentCode">
              <el-select
                v-model="filterForm.paymentCode"
                :placeholder="$t('common.components.select.placeholder')"
                clearable
                filterable
                :disabled="!filterForm.paymentEnabled"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in params.gkindpay.data"
                  :key="item.kindpay"
                  :label="item.kindname"
                  :value="item.kindpay"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox v-model="filterForm.sumEnabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.sumRange.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div style="text-align: center">
                {{ $t("common.filter.form.sumRange.from") }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="sumRange">
              <currency-input
                placeholder="0.00"
                v-model.lazy="filterForm.sumBegin"
                :disabled="!filterForm.sumEnabled"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: !filterForm.sumEnabled }"
                style="width: 100%; height: 36px; line-height: 36px;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div style="text-align: center">
                {{ $t("common.filter.form.sumRange.to") }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <currency-input
                placeholder="0.00"
                v-model.lazy="filterForm.sumEnd"
                :disabled="!filterForm.sumEnabled"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: !filterForm.sumEnabled }"
                style="width: 100%; height: 36px; line-height: 36px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox v-model="filterForm.showSpacedEnabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <div>{{ $t("common.filter.form.showSpaced.title") }}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="filterModalSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button type="plain" size="small" @click="filterModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col></el-row
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="titleInfoModal"
      :visible.sync="infoModal"
      :close-on-click-modal="false"
      @open="infoModalShow"
      @close="infoModalHide"
      :width="largeDialogWidth"
      top="2em"
      v-draggable
    >
      <el-row type="flex" justify="space-between">
        <el-col :span="24">
          <div class="grid-container-modal">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :columnDefs="sourceInfoModal"
              :rowData="infoReceipts"
              :defaultColDef="defaultColDef"
              :gridOptions="infoReceiptsGridOptions"
              @grid-ready="onInfoReceiptsGridReady"
              @first-data-rendered="onInfoReceiptsFirstDataRendered"
              @gridSizeChanged="onGridSizeChanged"
              @modelUpdated="onInfoReceiptsModelUpdated"
              @cellContextMenu="onInfoReceiptsRowRightClicked"
            ></ag-grid-vue>
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="infoModal = false"
          ><span class="key-name">Esc</span
          >{{ $t("common.buttons.close") }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="titleEditModal"
      :visible.sync="editModal"
      :close-on-click-modal="false"
      @open="editModalShow"
      @close="editModalHide"
      :width="largeDialogWidth"
      top="1em"
      class="resize"
      center
      v-draggable
    >
      <el-form :model="editForm" :rules="editRules" ref="editForm">
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item
              :label="$t('packsreceipts.editForm.form.packnumber')"
              label-width="180px"
            >
              <el-input
                v-model="editForm.packnumber"
                clearable
                style="width: 90%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item
              :label="$t('packsreceipts.editForm.form.datebank')"
              label-width="160px"
            >
              <el-date-picker
                v-model="editForm.datebank"
                :disabled="editFieldDisabled"
                type="date"
                :placeholder="$t('common.components.datePicker.placeholder')"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :picker-options="pickerOptions"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              :label="$t('packsreceipts.editForm.form.codefirme')"
              label-width="180px"
            >
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="4">
                  <el-input
                    v-model="editForm.mfo"
                    clearable
                    style="width: 100%;"
                    @input="onChangeMfo"
                    :disabled="editFieldDisabled"
                  ></el-input>
                </el-col>
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="editForm.codefirmeCode"
                    @blur="onChangeCodefirmeCode"
                    @keyup.enter.native="onChangeCodefirmeCode"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    :class="{ moneydisable: editFieldDisabled }"
                    style="width: 100%; height: 37px; line-height: 37px;"
                  />
                </el-col>
                <el-col :span="18">
                  <el-select
                    v-model="editForm.codefirme"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    style="width: 100%;"
                    :disabled="editFieldDisabled"
                  >
                    <el-option
                      v-for="item in editForm.senders"
                      :key="item.codefirme"
                      :label="item.namefirme"
                      :value="item.codefirme"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              prop="accountSender"
              :label="$t('packsreceipts.editForm.form.accountSender')"
              label-width="180px"
            >
              <el-input
                v-model="editForm.accountSender"
                style="width: 100%;"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              prop="kindpay"
              :label="$t('packsreceipts.editForm.form.kindpay')"
              label-width="180px"
            >
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="editForm.kindpayCode"
                    @blur="onChangeKindpayCode"
                    @keyup.enter.native="onChangeKindpayCode"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    :class="{ moneydisable: editFieldDisabled }"
                    style="width: 100%; height: 37px; line-height: 37px;"
                  />
                </el-col>

                <el-col :span="22">
                  <el-select
                    v-model="editForm.kindpay"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    style="width: 100%;"
                    :disabled="editFieldDisabled"
                  >
                    <el-option
                      v-for="item in editForm.payments"
                      :key="item.kindpay"
                      :label="item.kindname"
                      :value="item.kindpay"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item
              prop="quantity"
              :label="labelQuantity"
              label-width="180px"
            >
              <el-input-number
                v-model.lazy="editForm.quantity"
                :disabled="editFieldDisabled"
                controls-position="right"
                :min="1"
                :max="65535"
                style="width: 90%;"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item
              prop="countband"
              :label="labelCountband"
              label-width="180px"
            >
              <el-input-number
                v-model.lazy="editForm.countband"
                :disabled="editFieldDisabled"
                controls-position="right"
                :min="1"
                :max="65535"
                style="width: 90%;"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item
              prop="summa"
              :label="$t('packsreceipts.editForm.form.summa')"
              label-width="180px"
            >
              <currency-input
                placeholder="0.00"
                v-model.lazy="editForm.summa"
                :disabled="editFieldDisabled"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: editFieldDisabled }"
                style="width: 90%; height: 36px; line-height: 36px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item
              v-if="visibleSumprof"
              :label="$t('packsreceipts.editForm.form.sumprof')"
              label-width="180px"
            >
              <currency-input
                placeholder="0.00"
                v-model.lazy="editForm.sumprof"
                class="el-input--small el-input__inner"
                style="width: 90%; height: 36px; line-height: 36px"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="visibleOperator" type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              prop="userid"
              :label="$t('packsreceipts.editForm.form.userid')"
              label-width="180px"
            >
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="editForm.useridCode"
                    @blur="onChangeUseridCode"
                    @keyup.enter.native="onChangeUseridCode"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    :class="{ moneydisable: editFieldDisabled }"
                    style="width: 100%; height: 37px; line-height: 37px;"
                  />
                </el-col>

                <el-col :span="22">
                  <el-select
                    v-model="editForm.userid"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    style="width: 100%;"
                    :disabled="editFieldDisabled"
                  >
                    <el-option
                      v-for="item in params.guserspackedit.data"
                      :key="item.userid"
                      :label="item.fio"
                      :value="item.userid"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <div v-if="statusModify === 'add'">
              <el-button
                type="primary"
                size="small"
                @click="insertModalSubmit"
                native-type="submit"
                v-shortkey="{
                  Insert: ['insert'],
                  Plus: ['+']
                }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">Ins</span
                >{{ $t("common.buttons.add") }}</el-button
              >
            </div>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="editModalSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button type="plain" size="small" @click="editModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog
      :title="titleImportModal"
      :visible.sync="importModal"
      :close-on-click-modal="false"
      @open="importModalShow"
      @close="importModalHide"
      :width="dialogWidth"
      top="1em"
      class="resize"
      v-draggable
    >
      <el-dialog
        width="40%"
        :title="$t('packsreceipts.confirmDateBank.modal.title')"
        :visible.sync="confirmDateBankModal"
        :close-on-click-modal="false"
        @open="confirmDateBankModalShow"
        @close="confirmDateBankModalHide"
        append-to-body
        center
        v-draggable
      >
        <el-form
          :model="confirmDateBankForm"
          :rules="confirmDateBankRules"
          ref="confirmDateBankForm"
        >
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item>
                <div>
                  {{ $t("packsreceipts.confirmDateBank.form.description") }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item>
                <div>
                  {{ $t("packsreceipts.confirmDateBank.form.dateBank") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="dateBank">
                <el-date-picker
                  v-model="confirmDateBankForm.dateBank"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-row type="flex" justify="space-between">
            <el-col :span="24" style="text-align:right;">
              <el-button
                type="primary"
                size="small"
                @click="confirmDateBankSubmit"
                v-shortkey="{ F10: ['f10'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F10</span
                >{{ $t("common.buttons.submit") }}</el-button
              >
              <el-button
                type="plain"
                size="small"
                @click="confirmDateBankCancel"
                ><span class="key-name">Esc</span
                >{{ $t("common.buttons.cancel") }}</el-button
              >
            </el-col>
          </el-row>
        </span>
      </el-dialog>

      <el-dialog
        width="35%"
        :title="$t('packsreceipts.uploadForm.modal.title')"
        :visible.sync="uploadFilesModal"
        :close-on-click-modal="false"
        @close="uploadFilesModalHide"
        append-to-body
        center
        v-draggable
      >
        <el-form :model="uploadForm" :rules="uploadRules" ref="uploadForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item
                prop="uploadfile"
                :label="$t('packsreceipts.uploadForm.form.uploadfile')"
              >
                <el-upload
                  action
                  ref="upload"
                  :accept="fileMask"
                  :auto-upload="false"
                  :multiple="multiupload"
                >
                  <el-button
                    slot="trigger"
                    size="small"
                    type="primary"
                    icon="fas fa-folder"
                    >{{ $t("common.buttons.selectFile") }}</el-button
                  >
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-row type="flex" justify="space-between">
            <el-col :span="24" style="text-align:right;">
              <el-button
                type="primary"
                size="small"
                @click="uploadFilesSubmit"
                v-shortkey="{ F10: ['f10'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F10</span
                >{{ $t("common.buttons.submit") }}</el-button
              >
              <el-button
                type="plain"
                size="small"
                @click="uploadFilesModal = false"
                ><span class="key-name">Esc</span
                >{{ $t("common.buttons.cancel") }}</el-button
              >
            </el-col>
          </el-row>
        </span>
      </el-dialog>

      <el-dialog
        width="40%"
        :title="$t('packsreceipts.confirmSender.modal.title')"
        :visible.sync="confirmSenderModal"
        :close-on-click-modal="false"
        @open="confirmSenderModalShow"
        @close="confirmSenderModalHide"
        append-to-body
        center
        v-draggable
      >
        <el-form
          :model="confirmSenderForm"
          :rules="confirmSenderRules"
          ref="confirmSenderForm"
        >
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item>
                <div>
                  <span class="red-star">*</span>
                  {{ $t("packsreceipts.confirmSender.form.orgSendPack") }}
                </div>
                <div class="sender-filename">
                  {{ confirmSenderForm.fileName }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item prop="codefirme">
                <el-row type="flex" justify="space-between" :gutter="5">
                  <el-col :span="3">
                    <currency-input
                      placeholder=""
                      v-model="confirmSenderForm.codefirmeCode"
                      @blur="onChangeSenderCodefirmeCode"
                      @keyup.enter.native="onChangeSenderCodefirmeCode"
                      :precision="0"
                      class="el-input--small el-input__inner"
                      style="width: 100%; height: 37px; line-height: 37px;"
                    />
                  </el-col>

                  <el-col :span="21">
                    <el-select
                      v-model="confirmSenderForm.codefirme"
                      :placeholder="$t('common.components.select.placeholder')"
                      clearable
                      filterable
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in params.gfirme.data"
                        :key="item.codefirme"
                        :label="
                          item.rcount
                            ? `${item.namefirme}, ${$t(
                                'packsreceipts.confirmSender.form.rcount'
                              )} - ${item.rcount}`
                            : `${item.namefirme}`
                        "
                        :value="item.codefirme"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-row type="flex" justify="space-between">
            <el-col :span="24" style="text-align:right;">
              <el-button
                type="primary"
                size="small"
                @click="confirmSenderSubmit"
                native-type="submit"
                v-shortkey="{ F10: ['f10'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F10</span
                >{{ $t("common.buttons.submit") }}</el-button
              >
              <el-button type="plain" size="small" @click="confirmSenderCancel"
                ><span class="key-name">Esc</span
                >{{ $t("common.buttons.cancel") }}</el-button
              >
            </el-col>
          </el-row>
        </span>
      </el-dialog>

      <el-dialog
        width="40%"
        :title="$t('packsreceipts.confirmSenderMfo.modal.title')"
        :visible.sync="confirmSenderMfoModal"
        :close-on-click-modal="false"
        @open="confirmSenderMfoModalShow"
        @close="confirmSenderMfoModalHide"
        append-to-body
        center
        v-draggable
      >
        <el-form
          :model="confirmSenderMfoForm"
          :rules="confirmSenderMfoRules"
          ref="confirmSenderMfoForm"
        >
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item>
                <div>
                  <span class="red-star">*</span>
                  {{ $t("packsreceipts.confirmSenderMfo.form.orgSendPack") }}
                </div>
                <div class="sender-filename">
                  {{ $t("packsreceipts.confirmSenderMfo.form.mfo") }}
                  {{ confirmSenderMfoForm.mfo }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item prop="codefirme">
                <el-row type="flex" justify="space-between" :gutter="5">
                  <el-col :span="3">
                    <currency-input
                      placeholder=""
                      v-model="confirmSenderMfoForm.codefirmeCode"
                      @blur="onChangeSenderMfoCodefirmeCode"
                      @keyup.enter.native="onChangeSenderMfoCodefirmeCode"
                      :precision="0"
                      class="el-input--small el-input__inner"
                      style="width: 100%; height: 37px; line-height: 37px;"
                    />
                  </el-col>

                  <el-col :span="21">
                    <el-select
                      v-model="confirmSenderMfoForm.codefirme"
                      :placeholder="$t('common.components.select.placeholder')"
                      clearable
                      filterable
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in confirmSenderMfoForm.senders"
                        :key="item.codefirme"
                        :label="
                          item.rcount
                            ? `${item.namefirme}, ${$t(
                                'packsreceipts.confirmSenderMfo.form.rcount'
                              )} - ${item.rcount}`
                            : `${item.namefirme}`
                        "
                        :value="item.codefirme"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-row type="flex" justify="space-between">
            <el-col :span="24" style="text-align:right;">
              <el-button
                type="primary"
                size="small"
                @click="confirmSenderMfoSubmit"
                native-type="submit"
                v-shortkey="{ F10: ['f10'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F10</span
                >{{ $t("common.buttons.submit") }}</el-button
              >
              <el-button
                type="plain"
                size="small"
                @click="confirmSenderMfoCancel"
                ><span class="key-name">Esc</span
                >{{ $t("common.buttons.cancel") }}</el-button
              >
            </el-col>
          </el-row>
        </span>
      </el-dialog>

      <el-dialog
        width="40%"
        :title="$t('packsreceipts.confirmDestLink.modal.title')"
        :visible.sync="confirmDestLinkModal"
        :close-on-click-modal="false"
        @close="confirmDestLinkModalHide"
        append-to-body
        top="2em"
        v-draggable
      >
        <el-form
          :model="confirmDestLinkForm"
          :rules="confirmDestLinkRules"
          ref="confirmDestLinkForm"
        >
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-card shadow="never">
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-form-item>
                      <div>
                        {{
                          $t("packsreceipts.confirmDestLink.modal.description")
                        }}
                      </div>
                      <div class="sender-filename">
                        {{ confirmDestLinkForm.namebankcodeplat }} ({{
                          $t("packsreceipts.confirmDestLink.modal.code")
                        }}
                        {{ confirmDestLinkForm.bankcodeplat }})
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-row type="flex" justify="space-between" :gutter="5">
                      <el-col :span="4">
                        <currency-input
                          placeholder=""
                          v-model="confirmDestLinkForm.codeplatCode"
                          @blur="onChangeConfirmDestLinkCode"
                          @keyup.enter.native="onChangeConfirmDestLinkCode"
                          :precision="0"
                          class="el-input--small el-input__inner"
                          style="width: 100%; height: 36px; line-height: 36px;"
                        />
                      </el-col>
                      <el-col :span="20">
                        <el-form-item prop="codeplat">
                          <el-select
                            v-model="confirmDestLinkForm.codeplat"
                            :placeholder="
                              $t('common.components.select.placeholder')
                            "
                            clearable
                            filterable
                            style="width: 100%;"
                          >
                            <el-option
                              v-for="item in params.codepay.data"
                              :key="item.codeplat"
                              :label="item.name"
                              :value="item.codeplat"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-card shadow="never" style="margin-top: 10px;">
                <div slot="header">
                  <span class="card-font-header">{{
                    $t("packsreceipts.confirmDestLink.modal.additionallyImport")
                  }}</span>
                </div>
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-checkbox v-model="confirmDestLinkForm.withvalue">{{
                      $t(
                        "packsreceipts.confirmDestLink.modal.additionallyMeterReading"
                      )
                    }}</el-checkbox>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-row type="flex" justify="space-between">
            <el-col :span="24" style="text-align:right;">
              <el-button
                type="primary"
                size="small"
                @click="confirmDestLinkSubmit"
                native-type="submit"
                v-shortkey="{ F10: ['f10'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F10</span
                >{{ $t("common.buttons.submit") }}</el-button
              >
              <el-button
                type="plain"
                size="small"
                @click="confirmDestLinkCancel"
                ><span class="key-name">Esc</span
                >{{ $t("common.buttons.cancel") }}</el-button
              >
            </el-col>
          </el-row>
        </span>
      </el-dialog>

      <el-dialog
        width="40%"
        :title="$t('packsreceipts.confirmSenderMfoNumber.modal.title')"
        :visible.sync="confirmSenderMfoNumberModal"
        :close-on-click-modal="false"
        @open="confirmSenderMfoNumberModalShow"
        @close="confirmSenderMfoNumberModalHide"
        append-to-body
        center
        v-draggable
      >
        <el-form
          :model="confirmSenderMfoNumberForm"
          :rules="confirmSenderMfoNumberRules"
          ref="confirmSenderMfoNumberForm"
        >
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item>
                <div>
                  <span class="red-star">*</span>
                  {{
                    $t("packsreceipts.confirmSenderMfoNumber.modal.description")
                  }}
                </div>
                <div class="sender-filename">
                  {{ $t("packsreceipts.confirmSenderMfoNumber.modal.mfo") }}
                  {{ confirmSenderMfoNumberForm.mfo }},
                  {{ $t("packsreceipts.confirmSenderMfoNumber.modal.number") }}
                  {{ confirmSenderMfoNumberForm.number }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item prop="codefirme">
                <el-row type="flex" justify="space-between" :gutter="5">
                  <el-col :span="4">
                    <currency-input
                      placeholder=""
                      v-model="confirmSenderMfoNumberForm.codefirmeCode"
                      @blur="onChangeSenderMfoNumberCode"
                      @keyup.enter.native="onChangeSenderMfoNumberCode"
                      :precision="0"
                      class="el-input--small el-input__inner"
                      style="width: 100%; height: 36px; line-height: 36px;"
                    />
                  </el-col>
                  <el-col :span="20">
                    <el-select
                      v-model="confirmSenderMfoNumberForm.codefirme"
                      :placeholder="$t('common.components.select.placeholder')"
                      clearable
                      filterable
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in this.confirmSenderMfoNumberForm.firms"
                        :key="item.codefirme"
                        :label="
                          item.rcount
                            ? `${item.namefirme}, ${$t(
                                'packsreceipts.confirmSender.form.rcount'
                              )} - ${item.rcount}`
                            : `${item.namefirme}`
                        "
                        :value="item.codefirme"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-row type="flex" justify="space-between">
            <el-col :span="24" style="text-align:right;">
              <el-button
                type="primary"
                size="small"
                @click="confirmSenderMfoNumberSubmit"
                native-type="submit"
                v-shortkey="{ F10: ['f10'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F10</span
                >{{ $t("common.buttons.submit") }}</el-button
              >
              <el-button
                type="plain"
                size="small"
                @click="confirmSenderMfoNumberCancel"
                ><span class="key-name">Esc</span
                >{{ $t("common.buttons.cancel") }}</el-button
              >
            </el-col>
          </el-row>
        </span>
      </el-dialog>

      <div ref="importFormInfo">
        <el-form :model="importForm" :rules="importRules" ref="importForm">
          <el-row type="flex" justify="space-between" :gutter="5">
            <el-col :span="6">
              <el-form-item>
                <div>
                  <span class="red-star">*</span
                  >{{ $t("packsreceipts.import.form.codeimport") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <currency-input
                placeholder=""
                v-model="importForm.codeimportCode"
                @blur="onChangeImportCodeimportCode"
                @keyup.enter.native="onChangeImportCodeimportCode"
                :precision="0"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: importForm.codeimportDisabled }"
                style="width: 100%; height: 37px; line-height: 37px;"
              />
            </el-col>
            <el-col :span="16">
              <el-form-item prop="codeimport">
                <el-select
                  v-model="importForm.codeimport"
                  :placeholder="$t('common.components.select.placeholder')"
                  clearable
                  filterable
                  style="width: 100%;"
                  :disabled="importForm.codeimportDisabled"
                  :loading="importTypesLoading"
                >
                  <el-option
                    v-for="item in importTypes"
                    :key="item.codeimport"
                    :label="item.nameimport"
                    :value="item.codeimport"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between" :gutter="5">
            <el-col :span="6">
              <el-form-item style="margin-bottom: 7px;">
                <div>
                  <span class="red-star">*</span
                  >{{ $t("packsreceipts.import.form.kindpay") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <currency-input
                placeholder=""
                v-model="importForm.kindpayCode"
                @blur="onChangeImportKindpayCode"
                @keyup.enter.native="onChangeImportKindpayCode"
                :precision="0"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: importForm.kindpayDisabled }"
                style="width: 100%; height: 37px; line-height: 37px; margin-bottom: 7px;"
              />
            </el-col>
            <el-col :span="16">
              <el-form-item prop="kindpay" style="margin-bottom: 7px;">
                <el-select
                  v-model="importForm.kindpay"
                  :placeholder="$t('common.components.select.placeholder')"
                  clearable
                  filterable
                  style="width: 100%;"
                  :disabled="importForm.kindpayDisabled"
                >
                  <el-option
                    v-for="item in importForm.payments"
                    :key="item.kindpay"
                    :label="item.kindname"
                    :value="item.kindpay"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row
            v-if="this.params.importpack.showpayservice === '1'"
            type="flex"
            justify="space-between"
            style="margin-top: 15px;"
            :gutter="5"
          >
            <el-col :span="24">
              <el-card class="box-card">
                <div slot="header">
                  {{ $t("packsreceipts.import.form.codepayRadio.title") }}
                </div>
                <el-row
                  v-if="this.params.importpack.showpayservice === '1'"
                  type="flex"
                  justify="space-between"
                >
                  <el-col :span="24">
                    <el-form-item style="margin-bottom: 7px;">
                      <el-radio
                        v-model="importForm.codepayRadio"
                        label="file"
                        >{{
                          $t("packsreceipts.import.form.codepayRadio.file")
                        }}</el-radio
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  v-if="this.params.importpack.showpayservice === '1'"
                  type="flex"
                  justify="space-between"
                  :gutter="5"
                >
                  <el-col :span="6">
                    <el-form-item style="margin-bottom: 7px;">
                      <el-radio
                        v-model="importForm.codepayRadio"
                        label="customer"
                        >{{
                          $t("packsreceipts.import.form.codepayRadio.customer")
                        }}</el-radio
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <currency-input
                      placeholder=""
                      v-model="importForm.codepayCode"
                      @blur="onChangeImportCodepayCode"
                      @keyup.enter.native="onChangeImportCodepayCode"
                      :precision="0"
                      class="el-input--small el-input__inner"
                      :class="{ moneydisable: !importForm.codepayEnabled }"
                      style="width: 100%; height: 37px; line-height: 37px; margin-bottom: 7px;"
                    />
                  </el-col>
                  <el-col :span="16">
                    <el-form-item prop="codepay" style="margin-bottom: 7px;">
                      <el-select
                        v-model="importForm.codepay"
                        :placeholder="
                          $t('common.components.select.placeholder')
                        "
                        clearable
                        filterable
                        style="width: 100%;"
                        :disabled="!importForm.codepayEnabled"
                      >
                        <el-option
                          v-for="item in params.codepay.data"
                          :key="item.codeplat"
                          :label="item.name"
                          :value="item.codeplat"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>

          <el-row
            type="flex"
            justify="space-between"
            style="margin-top: 20px;"
            :gutter="5"
          >
            <el-col :span="24">
              <el-button-group class="button-group">
                <el-button
                  type="primary"
                  size="small"
                  :disabled="addImportFileBtnDisabled"
                  @click="onAddImportFileBtn"
                  v-shortkey="{ Insert: ['insert'], Plus: ['+'] }"
                  @shortkey.native="onShortKeyRouter"
                  ><span class="key-name">Ins</span
                  >{{ $t("common.buttons.addFile") }}</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  :disabled="deleteImportFileBtnDisabled"
                  @click="onDeleteImportFileBtn"
                  v-shortkey="{ Del: ['del'], Minus: ['-'] }"
                  @shortkey.native="onShortKeyRouter"
                  ><span class="key-name">Del</span
                  >{{ $t("common.buttons.deleteFile") }}</el-button
                >
              </el-button-group>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between" :gutter="5">
            <el-col :span="24">
              <div class="grid-import-modal">
                <ag-grid-vue
                  style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
                  class="ag-theme-balham"
                  rowSelection="single"
                  :columnDefs="importFilesColumnDefs"
                  :rowData="importFiles"
                  :defaultColDef="defaultColDef"
                  :gridOptions="importFilesGridOptions"
                  @grid-ready="onImportFilesGridReady"
                  @first-data-rendered="onImportFilesFirstDataRendered"
                  @gridSizeChanged="onGridSizeChanged"
                  @modelUpdated="onImportFilesModelUpdated"
                  @rowSelected="onImportFilesRowSelected"
                  @cellContextMenu="onImportFilesRowRightClicked"
                ></ag-grid-vue>
              </div>
              <el-form-item prop="files"> </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between" :gutter="5">
            <el-col :span="24">
              <el-form-item :label="$t('packsreceipts.import.form.fileinfo')">
                <el-input
                  v-model="importForm.fileinfo"
                  type="textarea"
                  :rows="5"
                  :disabled="true"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              v-if="importBtnVisible"
              type="primary"
              size="small"
              @click="importModalSubmit"
              v-shortkey="{ F3: ['f3'] }"
              @shortkey.native="onShortKeyRouter"
              native-type="submit"
              ><span class="key-name">F3</span
              >{{ $t("common.buttons.imports") }}</el-button
            >
            <el-button
              v-if="reportBtnVisible"
              type="primary"
              size="small"
              @click="importModalReport"
              v-shortkey="{ F2: ['f2'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F2</span
              >{{ $t("common.buttons.report") }}</el-button
            >
            <el-button type="plain" size="small" @click="importModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <Payment></Payment>
  </div>
</template>

<script>
import { nameFirme, kindName, formatSum, sortSum } from "@/helpers/reference";
import { mapGetters, mapActions } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import { $, gt } from "moneysafe";
import Payment from "@/components/Payment";
import { setGridView } from "@/helpers/grid";
import { pickerOptions } from "@/mixins/pickerOptions";
import { dialogWidth } from "@/mixins/dialogWidth";
import { checkAccess } from "@/helpers/access";

export default {
  name: "packsreceipts",
  components: {
    AgGridVue,
    Payment
  },
  mixins: [pickerOptions, dialogWidth],
  data() {
    const validateDateRange = (rule, value, callback) => {
      if (this.filterForm.dateEnabled && !value) {
        callback(new Error(this.$t("common.validations.dateRange.message")));
      } else {
        callback();
      }
    };
    const validateOrganizationCode = (rule, value, callback) => {
      if (this.filterForm.organizationEnabled && !value) {
        callback(
          new Error(this.$t("common.validations.confirmeCodefirme.message"))
        );
      } else {
        callback();
      }
    };
    const validatePaymentCode = (rule, value, callback) => {
      if (this.filterForm.paymentEnabled && !value) {
        callback(new Error(this.$t("common.validations.payment.message")));
      } else {
        callback();
      }
    };
    const validateSumRange = (rule, value, callback) => {
      if (
        this.filterForm.sumEnabled &&
        gt($(this.filterForm.sumBegin), $(this.filterForm.sumEnd))
      ) {
        callback(new Error(this.$t("common.validations.sumRange.message")));
      } else {
        callback();
      }
    };
    const validateRcount = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.rcount.message")));
      } else {
        callback();
      }
    };
    const validatePayment = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.payment.message")));
      } else {
        callback();
      }
    };
    const validateSummaPack = (rule, value, callback) => {
      const kind = this.params.gkindpay.data.filter(
        item => item.kindpay === this.editForm.kindpay
      );
      const negsum = kind.length > 0 ? kind[0].negsum : "";
      if (value < 0 && negsum === "0") {
        callback(new Error(this.$t("common.validations.summaPack.aboveZero")));
      } else if (value === 0 && this.params.goptions.allowzeropays !== "yes") {
        callback(
          new Error(this.$t("common.validations.summaPack.notEqualZero"))
        );
      } else {
        callback();
      }
    };
    const validateUserPayment = (rule, value, callback) => {
      if (this.visibleOperator && !value) {
        callback(new Error(this.$t("common.validations.userPayment.message")));
      } else {
        callback();
      }
    };
    const validateCodeImport = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.codeImport.message")));
      } else {
        callback();
      }
    };
    const validateKindpay = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.payment.message")));
      } else {
        callback();
      }
    };
    const validateCodepay = (rule, value, callback) => {
      if (!value && this.importForm.codepayEnabled) {
        callback(new Error(this.$t("common.validations.codepay.message")));
      } else {
        callback();
      }
    };
    const validateFiles = (rule, value, callback) => {
      if (this.importFormStatus === "0" && this.importFiles.length === 0) {
        callback(new Error(this.$t("common.validations.files.message")));
      } else {
        callback();
      }
    };
    const validateUploadFile = (rule, value, callback) => {
      if (this.$refs.upload.uploadFiles.length === 0) {
        callback(new Error(this.$t("common.validations.uploadFile.message")));
      } else if (
        !this.multiupload &&
        this.$refs.upload.uploadFiles.length > 1
      ) {
        callback(new Error(this.$t("common.validations.uploadFile.onlyOne")));
      } else {
        callback();
      }
    };
    const validateСodefirme = (rule, value, callback) => {
      if (!value) {
        callback(
          new Error(this.$t("common.validations.confirmeCodefirme.message"))
        );
      } else {
        callback();
      }
    };
    const validateСodeplat = (rule, value, callback) => {
      if (!value) {
        callback(
          new Error(this.$t("common.validations.paymentStatus.message"))
        );
      } else {
        callback();
      }
    };
    const validateConfirmDateBank = (rule, value, callback) => {
      if (!value) {
        callback(
          new Error(this.$t("common.validations.confirmDateBank.message"))
        );
      } else {
        callback();
      }
    };
    return {
      agGridModules: AllCommunityModules,
      agGridlocaleText: null,
      packsReceiptsGridOptions: null,
      packsReceiptsGridApi: null,
      packsReceiptsColumnApi: null,
      packsReceiptsPinnedBottomRowData: null,
      infoReceiptsGridOptions: null,
      infoReceiptsGridApi: null,
      infoReceiptsColumnApi: null,
      importFilesGridOptions: null,
      importFilesGridApi: null,
      importFilesColumnApi: null,
      getRowStyle: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      packsReceiptsColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.npackSystem"),
          headerTooltip: this.$t("common.gridColumns.npackSystem"),
          field: "npack",
          tooltipField: "npack"
        },
        {
          headerName: this.$t("common.gridColumns.namefirmeSender"),
          headerTooltip: this.$t("common.gridColumns.namefirmeSender"),
          field: "namefirme",
          tooltipField: "namefirme"
        },
        {
          headerName: this.$t("common.gridColumns.datebank"),
          headerTooltip: this.$t("common.gridColumns.datebank"),
          field: "datebank",
          tooltipField: "datebank",
          sort: "asc",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
        },
        {
          headerName: this.$t("common.gridColumns.kindname"),
          headerTooltip: this.$t("common.gridColumns.kindname"),
          field: "kindname",
          tooltipField: "kindname"
        },
        {
          headerName: this.$t("common.gridColumns.countband"),
          headerTooltip: this.$t("common.gridColumns.countband"),
          field: "countband",
          tooltipField: "countband",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.quantity"),
          headerTooltip: this.$t("common.gridColumns.quantity"),
          field: "quantity",
          tooltipField: "quantity",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.summa"),
          headerTooltip: this.$t("common.gridColumns.summa"),
          field: "summa",
          tooltipField: "summa",
          cellClass: "sum-column",
          valueFormatter: params => formatSum(params.value),
          comparator: (sum1, sum2) => sortSum(sum1, sum2)
        },
        {
          headerName: this.$t("common.gridColumns.sumprof"),
          headerTooltip: this.$t("common.gridColumns.sumprof"),
          field: "sumprof",
          tooltipField: "sumprof",
          cellClass: "sum-column",
          valueFormatter: params => formatSum(params.value),
          comparator: (sum1, sum2) => sortSum(sum1, sum2)
        },
        {
          headerName: this.$t("common.gridColumns.isimport"),
          headerTooltip: this.$t("common.gridColumns.isimport"),
          field: "isimport",
          tooltipValueGetter: params =>
            params.value === "1"
              ? this.$t("common.types.astatus.yes")
              : this.$t("common.types.astatus.no"),
          cellRenderer: params => {
            if (params.node.rowPinned) return "";
            return params.value === "1"
              ? "<input type=checkbox checked disabled>"
              : "<input type=checkbox disabled>";
          }
        }
      ],
      deletedPacksColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.packnumber"),
          headerTooltip: this.$t("common.gridColumns.packnumber"),
          field: "packnumber",
          tooltipField: "packnumber"
        },
        {
          headerName: this.$t("common.gridColumns.summa"),
          headerTooltip: this.$t("common.gridColumns.summa"),
          field: "summa",
          tooltipField: "summa",
          cellClass: "sum-column",
          valueFormatter: params => formatSum(params.value),
          comparator: (sum1, sum2) => sortSum(sum1, sum2)
        },
        {
          headerName: this.$t("common.gridColumns.countbands"),
          headerTooltip: this.$t("common.gridColumns.countbands"),
          field: "countband",
          tooltipField: "countband",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.quantitys"),
          headerTooltip: this.$t("common.gridColumns.quantitys"),
          field: "quantity",
          tooltipField: "quantity",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.kindname"),
          headerTooltip: this.$t("common.gridColumns.kindname"),
          field: "kindname",
          tooltipField: "kindname"
        },
        {
          headerName: this.$t("common.gridColumns.datebank"),
          headerTooltip: this.$t("common.gridColumns.datebank"),
          field: "datebank",
          tooltipField: "datebank",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
        },
        {
          headerName: this.$t("common.gridColumns.namefirme"),
          headerTooltip: this.$t("common.gridColumns.namefirme"),
          field: "namefirme",
          tooltipField: "namefirme"
        },
        {
          headerName: this.$t("common.gridColumns.nameaccount"),
          headerTooltip: this.$t("common.gridColumns.nameaccount"),
          field: "countfirme",
          tooltipField: "countfirme"
        },
        {
          headerName: this.$t("common.gridColumns.dateDelete"),
          headerTooltip: this.$t("common.gridColumns.dateDelete"),
          field: "datecurr",
          tooltipField: "datecurr",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY HH:mm:ss").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY HH:mm:ss").unix())
        },
        {
          headerName: this.$t("common.gridColumns.username"),
          headerTooltip: this.$t("common.gridColumns.username"),
          field: "username",
          tooltipField: "username"
        }
      ],
      indefiniteReceiptsColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.abcode"),
          headerTooltip: this.$t("common.gridColumns.abcode"),
          field: "abcode",
          tooltipField: "abcode"
        },
        {
          headerName: this.$t("common.gridColumns.fio"),
          headerTooltip: this.$t("common.gridColumns.fio"),
          field: "fio",
          tooltipField: "fio"
        },
        {
          headerName: this.$t("common.gridColumns.payname"),
          headerTooltip: this.$t("common.gridColumns.payname"),
          field: "payname",
          tooltipField: "payname"
        },
        {
          headerName: this.$t("common.gridColumns.summa"),
          headerTooltip: this.$t("common.gridColumns.summa"),
          field: "summpay",
          tooltipField: "summpay",
          cellClass: "sum-column",
          valueFormatter: params => formatSum(params.value),
          comparator: (sum1, sum2) => sortSum(sum1, sum2)
        },
        {
          headerName: this.$t("common.gridColumns.dateval"),
          headerTooltip: this.$t("common.gridColumns.dateval"),
          field: "dateval",
          tooltipField: "dateval",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
        },
        {
          headerName: this.$t("common.gridColumns.counter"),
          headerTooltip: this.$t("common.gridColumns.counter"),
          field: "counter",
          tooltipField: "counter",
          comparator: (value1, value2) =>
            parseFloat(value1) - parseFloat(value2)
        }
      ],
      importFilesColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.impFile"),
          headerTooltip: this.$t("common.gridColumns.impFile"),
          field: "impFile",
          tooltipField: "impFile",
          cellClass: "name-column",
          sort: "asc"
        },
        {
          headerName: this.$t("common.gridColumns.processed"),
          headerTooltip: this.$t("common.gridColumns.processed"),
          field: "processed",
          tooltipValueGetter: params =>
            params.value === "1"
              ? this.$t("common.types.processed.yes")
              : this.$t("common.types.processed.no"),
          cellRenderer: params => {
            return params.value === "1"
              ? "<input type=checkbox checked disabled>"
              : "<input type=checkbox disabled>";
          }
        }
      ],
      filterType: "primary",
      filterModal: false,
      filterForm: {
        dateEnabled: null,
        dateRange: [],
        organizationEnabled: null,
        organizationCode: null,
        paymentEnabled: null,
        paymentCode: null,
        sumEnabled: null,
        sumBegin: 0,
        sumEnd: 0,
        showSpacedEnabled: null
      },
      filterRules: {
        dateRange: [{ validator: validateDateRange, trigger: "blur" }],
        organizationCode: [
          { validator: validateOrganizationCode, trigger: "blur" }
        ],
        paymentCode: [{ validator: validatePaymentCode, trigger: "blur" }],
        sumRange: [{ validator: validateSumRange, trigger: "blur" }]
      },
      editModal: false,
      statusModify: null,
      statusInsert: null,
      editForm: {
        isimport: null,
        packnumber: null,
        datebank: null,
        mfo: null,
        codefirmeCode: null,
        codefirme: null,
        senders: [],
        accountSender: null,
        kindpayCode: null,
        kindpay: null,
        payments: [],
        quantity: null,
        countband: null,
        summa: 0,
        sumprof: 0,
        paysheetid: null,
        datebeginfact: null,
        npack: null,
        useridCode: null,
        userid: null
      },
      editRules: {
        accountSender: [
          { required: true, validator: validateRcount, trigger: "blur" }
        ],
        kindpay: [
          { required: true, validator: validatePayment, trigger: "blur" }
        ],
        quantity: [
          {
            required: true,
            message: this.$t("common.validations.quantity.required"),
            trigger: "blur"
          }
        ],
        countband: [
          {
            required: true,
            message: this.$t("common.validations.countband.required"),
            trigger: "blur"
          }
        ],
        summa: [
          { required: true, validator: validateSummaPack, trigger: "blur" }
        ],
        userid: [
          { required: true, validator: validateUserPayment, trigger: "blur" }
        ]
      },
      importModal: false,
      typeImport: null,
      titleImportModal: "",
      importForm: {
        codeimportCode: null,
        codeimport: null,
        codeimportDisabled: false,
        kindpayCode: null,
        kindpay: null,
        kindpayDisabled: false,
        fileinfo: "",
        payments: [],
        codepayCode: null,
        codepay: null,
        codepayEnabled: false,
        codepayRadio: "file"
      },
      importRules: {
        codeimport: [
          { required: true, validator: validateCodeImport, trigger: "blur" }
        ],
        kindpay: [
          { required: true, validator: validateKindpay, trigger: "blur" }
        ],
        codepay: [
          { required: true, validator: validateCodepay, trigger: "blur" }
        ],
        files: [{ required: true, validator: validateFiles, trigger: "blur" }]
      },
      addImportFileBtnDisabled: false,
      deleteImportFileBtnDisabled: true,
      uploadFilesModal: false,
      multiupload: true,
      uploadServerFolder: "",
      uploadForm: {},
      uploadRules: {
        uploadfile: [
          { required: true, validator: validateUploadFile, trigger: "blur" }
        ]
      },
      confirmDateBankModal: false,
      confirmDateBankForm: {
        dateBank: "",
        status: "0"
      },
      confirmDateBankRules: {
        dateBank: [
          {
            required: true,
            validator: validateConfirmDateBank,
            trigger: "blur"
          }
        ]
      },
      confirmSenderModal: false,
      confirmSenderForm: {
        fileName: "",
        codefirmeCode: null,
        codefirme: null,
        status: "0"
      },
      confirmSenderRules: {
        codefirme: [
          { required: true, validator: validateСodefirme, trigger: "blur" }
        ]
      },
      confirmSenderMfoModal: false,
      confirmSenderMfoForm: {
        mfo: "",
        selectCodefirme: "0",
        codefirmeCode: null,
        codefirme: null,
        senders: []
      },
      confirmSenderMfoRules: {
        codefirme: [
          { required: true, validator: validateСodefirme, trigger: "blur" }
        ]
      },
      confirmDestLinkModal: false,
      confirmDestLinkForm: {
        status: null,
        namebankcodeplat: "",
        bankcodeplat: null,
        codeplatCode: null,
        codeplat: null,
        withvalue: false
      },
      confirmDestLinkRules: {
        codeplat: [
          { required: true, validator: validateСodeplat, trigger: "blur" }
        ]
      },
      confirmSenderMfoNumberModal: false,
      confirmSenderMfoNumberForm: {
        status: null,
        mfo: "",
        number: "",
        codefirmeCode: null,
        codefirme: null,
        firms: []
      },
      confirmSenderMfoNumberRules: {
        codefirme: [
          { required: true, validator: validateСodefirme, trigger: "blur" }
        ]
      },
      money: {
        decimal: ".",
        thousands: " ",
        precision: 2
      },
      infoModal: false,
      typeInfoModal: null,
      titleInfoModal: "",
      sourceInfoModal: null,
      sourceInfoKey: "",
      currentPacksReceiptsRowSelected: null,
      addBtnDisabled: false,
      editBtnDisabled: false,
      deleteBtnDisabled: false,
      postingBtnDisabled: false,
      importBtnDisabled: false,
      deletePacksBtnDisabled: false,
      extraBtnDisabled: false,
      reportSubmitBtnDisabled: true,
      importBtnVisible: true,
      reportBtnVisible: false,
      statusCheck: null,
      titleEditModal: null,
      labelQuantity: null,
      labelCountband: null,
      visibleSumprof: true,
      visibleOperator: false,
      editFieldDisabled: false,
      lastRow: null,
      currentImportFilesRowSelected: null,
      importFormStatus: null,
      importFilesCurrentRow: null,
      importFilesProcessingCurrentRow: null,
      fileMask: "",
      importExtProp: {
        codeplat: false,
        datereq: false,
        codepage: ""
      },
      bankcodeplatOriginal: [],
      bankcodeplatResult: [],
      bankcodeplatProcessingCurrentRow: null,
      cfilOriginal: [],
      cfilResult: [],
      cfilProcessingCurrentRow: null,
      postingModal: false,
      modifyModal: false,
      statusModal: false,
      statusPayment: false
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "packsReceiptsFilter",
      "packsReceipts",
      "infoReceipts",
      "statusModifyPacksReceipts",
      "importTypes",
      "importTypesLoading",
      "importFiles",
      "importFilesBuffer",
      "statusInfoImportFile",
      "statusAddCodeplat",
      "statusLoadPackFile",
      "statusLoadPackFileCheck",
      "statusImportFileCodeFirme",
      "statusInfoPack",
      "statusAddBand",
      "paymentSubmit",
      "initPage",
      "loading",
      "params"
    ]),
    organizationName: function() {
      const code = this.packsReceiptsFilter.organization.code;
      return code ? nameFirme(this.params.gfirme.data, code) : "";
    },
    paymentName: function() {
      const code = this.packsReceiptsFilter.payment.code;
      return code ? kindName(this.params.gkindpay.data, code) : "";
    },
    checkAllModal: function() {
      return (
        !this.filterModal &&
        !this.editModal &&
        !this.importModal &&
        !this.uploadFilesModal &&
        !this.confirmDateBankModal &&
        !this.confirmSenderModal &&
        !this.confirmSenderMfoModal &&
        !this.confirmDestLinkModal &&
        !this.infoModal &&
        !this.postingModal &&
        !this.modifyModal &&
        !this.statusModal
      );
    }
  },
  watch: {
    statusModifyPacksReceipts: async function(value) {
      this.lastRow = "";
      // const nband = this.editForm.countband;
      const countpay = this.editForm.quantity;
      const summband = this.editForm.summa;
      const sumprof = this.editForm.sumprof;
      const datebank = this.editForm.datebank;
      const kindpay = this.editForm.kindpay;

      if (value && value.hasOwnProperty("question")) {
        this.statusCheck = null;

        let title;
        switch (this.statusModify) {
          case "add":
            title = this.$t("packsreceipts.statusModify.add");
            break;
          case "edit":
            title = this.$t("packsreceipts.statusModify.edit");
            break;
          case "delete":
            title = this.$t("packsreceipts.statusModify.delete");
            break;
          default:
            title = "";
        }

        this.modifyModal = true;
        for (const item of value.question) {
          try {
            await this.$confirm(item, title, {
              confirmButtonText: this.$t("common.buttons.confirmYes"),
              cancelButtonText: this.$t("common.buttons.confirmNo"),
              cancelButtonClass: "cancel-button",
              type: "warning"
            });
            this.statusCheck = true;
          } catch {
            this.statusCheck = false;
          }
          if (!this.statusCheck) break;
        }
        this.modifyModal = false;

        if (this.statusCheck && this.statusModify === "add") {
          this.confirmAdd("1");
        } else if (this.statusCheck && this.statusModify === "edit") {
          this.confirmEdit("1");
        } else if (this.statusCheck && this.statusModify === "delete") {
          this.confirmDelete("5");
        }
      } else if (value && value.hasOwnProperty("rows")) {
        if (this.statusInsert && this.statusModify === "add") {
          this.editForm.packnumber = "";
          this.editForm.codefirme = null;
          this.editForm.quantity = 1;
          this.editForm.countband = 1;
          this.editForm.summa = 0;
          this.editForm.sumprof = 0;
          this.editForm.userid = "";
        } else {
          this.editModal = false;
        }

        this.lastRow = value.hasOwnProperty("lastrow")
          ? value.lastrow.toString()
          : "";
        await this.getPacksReceipts();

        if (this.statusModify !== "delete" && this.statusPayment) {
          this.statusPayment = false;

          const npack = this.lastRow;

          const payload = {
            state: "add",
            npack,
            payid: "", // поле только для редактирования и удаления платежей
            date: datebank,
            sumPay: summband,
            kindpay: kindpay,
            countpay: 0, // поле только для добавления платежей на 3-й форме
            note: ""
          };
          this.$store.commit("setPaymentData", payload);

          this.$store.commit("clearStatusAddBand");
          await this.$store.dispatch("addBand", {
            npack,
            nband: "1", // уточнение алгоритма от 24.08.2021, для 2-ой формы Кол-во бандеролей всегда должно быть = 1
            countpay,
            summband,
            sumprof
          });
        }
      }
    },
    statusAddBand: function(value) {
      if (value) {
        this.$store.commit("setPaymentModal", true);
      }
    },
    "editForm.datebank": function(date) {
      if (date) {
        const currentDate = parseInt(this.$moment(date, "DD.MM.YYYY").unix());
        this.editForm.senders = this.params.gfirme.data.filter(
          item =>
            currentDate >=
              parseInt(this.$moment(item.datebegin, "DD.MM.YYYY").unix()) &&
            currentDate <=
              parseInt(this.$moment(item.dateend, "DD.MM.YYYY").unix()) &&
            ["1", "2", "4"].includes(item.codegroup)
        );
      } else {
        this.editForm.mfo = "";
        this.editForm.codefirme = null;
        this.editForm.senders = [];
        this.editForm.accountSender = "";
      }
    },
    "editForm.codefirme": function(codefirme) {
      this.editForm.codefirmeCode = +codefirme || null;
      if (codefirme) {
        const gfirme = this.params.gfirme.data.filter(
          item => item.codefirme === codefirme
        );
        this.editForm.mfo = gfirme.length > 0 ? gfirme[0].mfo : "";
        this.editForm.accountSender = gfirme.length > 0 ? gfirme[0].rcount : "";
      } else {
        this.editForm.mfo = "";
        this.editForm.accountSender = "";
      }
    },
    "editForm.kindpay": function(kindpay) {
      this.editForm.kindpayCode = +kindpay || null;
      if (kindpay && ["88", "91", "99"].includes(kindpay)) {
        this.visibleSumprof = false;
        this.visibleOperator = true;
        this.labelQuantity = this.$t(
          "packsreceipts.editForm.form.quantity.numberSubscribers"
        );
        this.labelCountband = this.$t(
          "packsreceipts.editForm.form.countband.numberSheets"
        );
        switch (kindpay) {
          case "88":
            this.titleEditModal = this.$t(
              "packsreceipts.editForm.modal.title.compensationVisually"
            );
            break;
          case "91":
            this.titleEditModal = this.$t(
              "packsreceipts.editForm.modal.title.socialSupplementInfo"
            );
            break;
          case "99":
            this.titleEditModal = this.$t(
              "packsreceipts.editForm.modal.title.grantInfo"
            );
            break;
        }
      } else {
        this.visibleSumprof = true;
        this.visibleOperator = false;
        this.labelQuantity = this.$t(
          "packsreceipts.editForm.form.quantity.numberReceipts"
        );
        this.labelCountband = this.$t(
          "packsreceipts.editForm.form.countband.numberCountband"
        );
        this.titleEditModal = this.$t(
          "packsreceipts.editForm.modal.title.packageInfo"
        );
      }
    },
    "editForm.userid": function(value) {
      this.editForm.useridCode = +value || null;
    },
    importTypes: function(value) {
      if (value) {
        if (value.length === 1) {
          this.importForm.codeimport = value[0].codeimport;
          this.importForm.codeimportDisabled = true;
        }
      }
    },
    "importForm.payments": function(value) {
      if (value) {
        if (value.length === 1) {
          this.importForm.kindpay = value[0].kindpay;
          this.importForm.kindpayDisabled = true;
        }
      }
    },
    "importForm.codeimport": function(value) {
      this.importForm.codeimportCode = +value || null;
      if (value) {
        const importType = this.importTypes.filter(
          item => item.codeimport === value
        );
        if (importType.length > 0) {
          this.fileMask = importType[0].filemask;

          this.importExtProp.codeplat =
            importType[0].extprop.hasOwnProperty("codeplat") &&
            importType[0].extprop.codeplat === 1
              ? true
              : false;
          this.importExtProp.datereq =
            importType[0].extprop.hasOwnProperty("datereq") &&
            importType[0].extprop.datereq === 1
              ? true
              : false;

          this.importExtProp.codepage = importType[0].extprop.hasOwnProperty(
            "codepage"
          )
            ? importType[0].extprop.codepage
            : "";
        }
      }
    },
    importFilesBuffer: function(value) {
      if (value.length > 0) {
        this.uploadFilesModal = false;

        this.importFilesCurrentRow = 0;
        this.checkImportFiles();
      }
    },
    statusInfoImportFile: function(value) {
      if (value) {
        const {
          countpack,
          datapack,
          errmess,
          kompack,
          sender,
          summapack,
          codefirme
        } = value.data[0];

        this.importFilesBuffer[
          this.importFilesCurrentRow
        ].countpack = countpack;
        this.importFilesBuffer[this.importFilesCurrentRow].datapack = datapack;
        this.importFilesBuffer[this.importFilesCurrentRow].errmess = errmess;
        this.importFilesBuffer[this.importFilesCurrentRow].kompack = kompack;
        this.importFilesBuffer[this.importFilesCurrentRow].sender = sender;
        this.importFilesBuffer[
          this.importFilesCurrentRow
        ].summapack = summapack;
        this.importFilesBuffer[
          this.importFilesCurrentRow
        ].codefirme = codefirme;
        this.importFilesBuffer[this.importFilesCurrentRow].processed = "0";
        this.importFilesBuffer[this.importFilesCurrentRow].bankcodeplat =
          value.bankcodeplat;
        this.importFilesBuffer[this.importFilesCurrentRow].cfil = value.cfil;

        if (errmess) {
          this.importFilesBuffer[this.importFilesCurrentRow].status = "1";
        }

        if (this.importExtProp.datereq && !errmess) {
          this.confirmDateBankModal = true;
        } else {
          this.importFilesCurrentRow += 1;
          this.checkImportFiles();
        }
      }
    },
    statusAddCodeplat: function(value) {
      if (value) {
        this.processingImportOneFile();
      }
    },
    statusLoadPackFile: function(value) {
      if (value && value.hasOwnProperty("result")) {
        this.completedImportOneFile();
      } else if (value && value.hasOwnProperty("question")) {
        const msg = value.question[0];
        const packdata = value.packdata;
        let behavior;

        this.statusModal = true;
        this.$confirm(msg, this.$t("packsreceipts.confirmImport.title"), {
          confirmButtonText: this.$t("common.buttons.confirmYes"),
          cancelButtonText: this.$t("common.buttons.confirmNo"),
          cancelButtonClass: "cancel-button",
          type: "warning"
        })
          .then(() => {
            this.statusModal = false;
            behavior = "1";
            this.$store.commit("clearStatusLoadPackFileCheck");
            this.$store.dispatch("loadPackFileCheck", {
              packdata,
              behavior
            });
          })
          .catch(() => {
            this.statusModal = false;
            behavior = "2";
            this.$store.commit("clearStatusLoadPackFileCheck");
            this.$store.dispatch("loadPackFileCheck", {
              packdata,
              behavior
            });
          });
      }
    },
    statusLoadPackFileCheck: function(value) {
      if (value && value.hasOwnProperty("result")) {
        this.completedImportOneFile();
      } else if (value && value.hasOwnProperty("errimport")) {
        const msg = value.errimport[0];
        this.errorImportOneFile(msg);
      }
    },
    statusImportFileCodeFirme: function(value) {
      if (
        value &&
        value.hasOwnProperty("data") &&
        value.hasOwnProperty("mfo")
      ) {
        this.confirmSenderMfoModal = true;
      } else if (value && Array.isArray(value.data) && value.data[0] === "OK") {
        const codeimport = this.importForm.codeimport;
        const kindpay = this.importForm.kindpay;
        const subs = this.typeImport;
        const fin = this.importFilesBuffer[this.importFilesCurrentRow].reeName;
        const fip = this.importFilesBuffer[this.importFilesCurrentRow].reePath;
        const codefirme = "";
        const codepage = this.importExtProp.codepage;

        this.$store.commit("setStatusInfoImportFile", false);
        this.$store.dispatch("getFileInfo", {
          codeimport,
          codefirme,
          codepage,
          kindpay,
          subs,
          fin,
          fip
        });
      } else if (value && Array.isArray(value.data) && value.data[0].errmess) {
        this.importFilesBuffer[this.importFilesCurrentRow].bankcodeplat = "";
        this.importFilesBuffer[this.importFilesCurrentRow].cfil = "";
        this.importFilesBuffer[this.importFilesCurrentRow].countpack = "";
        this.importFilesBuffer[this.importFilesCurrentRow].datapack = "";
        this.importFilesBuffer[this.importFilesCurrentRow].errmess =
          value.data[0].errmess;
        this.importFilesBuffer[this.importFilesCurrentRow].kompack = "";
        this.importFilesBuffer[this.importFilesCurrentRow].sender = "";
        this.importFilesBuffer[this.importFilesCurrentRow].summapack = "";
        this.importFilesBuffer[this.importFilesCurrentRow].codefirme = "";
        this.importFilesBuffer[this.importFilesCurrentRow].processed = "0";
        this.importFilesBuffer[this.importFilesCurrentRow].status = "1";

        this.importFilesCurrentRow += 1;
        this.checkImportFiles();
      }
    },
    "importForm.codepayEnabled": function(value) {
      this.importForm.codepayRadio = value === true ? "customer" : "file";
      if (!value) {
        this.importForm.codepay = null;
      }
    },
    "importForm.codepayRadio": function(value) {
      this.importForm.codepayEnabled = value === "customer" ? true : false;
    },
    "importForm.kindpay": function(value) {
      this.importForm.kindpayCode = +value || null;
    },
    "importForm.codepay": function(value) {
      this.importForm.codepayCode = +value || null;
    },
    "confirmSenderMfoForm.codefirme": function(value) {
      this.confirmSenderMfoForm.codefirmeCode = +value || null;
    },
    "confirmSenderForm.codefirme": function(value) {
      this.confirmSenderForm.codefirmeCode = +value || null;
    },
    "confirmSenderMfoNumberForm.codefirme": function(value) {
      this.confirmSenderMfoNumberForm.codefirmeCode = +value || null;
    },
    "confirmDestLinkForm.codeplat": function(value) {
      this.confirmDestLinkForm.codeplatCode = +value || null;
    },
    statusInfoPack: function(npack) {
      if (npack) {
        const message = `${this.$t(
          "controlpacks.statusInfoPack.pack"
        )} №${npack} ${this.$t("controlpacks.statusInfoPack.wasDeliver")}`;
        this.$alert(message, this.$t("controlpacks.statusInfoPack.title"), {
          confirmButtonText: this.$t("common.buttons.confirmOk"),
          callback: () => {
            this.getPacksReceipts();
          }
        });
      }
    },
    paymentSubmit: function(value) {
      if (value) {
        this.$store.commit("setPaymentModal", false);
      }
    }
  },
  beforeCreate() {
    if (!checkAccess(76)) {
      this.$router.push("/");
    }
  },
  async created() {
    document.title = this.$t("packsreceipts.title");
    await this.getParams({
      account: "1",
      gfirme: "1",
      gkindpay: "1",
      gusers: "1",
      codepay: "1",
      guserspackedit: "1",
      importpackpar: "1",
      street: "1",
      gregion: "1",
      statuspay: "1",
      gservice: "1",
      gzone: "1"
    });
    await this.getPacksReceipts();

    window.addEventListener("resize", this.onResize);
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.packsReceiptsGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.infoReceiptsGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.importFilesGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText,
      rowClassRules: {
        "ag-state-import-error": params =>
          params.data.status === "1" || params.data.errmess !== ""
      }
    };

    this.getRowStyle = params => {
      if (params.node.rowPinned) return { "font-weight": "bold" };
    };

    let filter;
    const savedFilter = this.$localStorage.get("wb-packsreceipts-filter");
    if (savedFilter) {
      filter = JSON.parse(savedFilter);
      if (isNaN(Number(filter.sum.sumBegin))) filter.sum.sumBegin = "0.00";
      if (isNaN(Number(filter.sum.sumEnd))) filter.sum.sumEnd = "0.00";
    } else {
      const dateBegin = this.$moment()
        .subtract(1, "months")
        .format("DD.MM.YYYY");
      const dateEnd = this.$moment()
        .add(1, "months")
        .format("DD.MM.YYYY");
      filter = {
        period: {
          enabled: true,
          dateBegin: dateBegin,
          dateEnd: dateEnd
        },
        organization: {
          enabled: false,
          code: null
        },
        payment: {
          enabled: false,
          code: null
        },
        sum: {
          enabled: false,
          sumBegin: null,
          sumEnd: null
        },
        showSpaced: {
          enabled: false
        }
      };
      this.$localStorage.set("wb-packsreceipts-filter", JSON.stringify(filter));
    }
    this.$store.commit("setPacksReceiptsFilter", filter);
  },
  beforeDestroy() {
    this.$store.commit("setPacksReceiptsFilter", {
      period: {
        enabled: false,
        dateBegin: "",
        dateEnd: ""
      },
      organization: {
        enabled: false,
        code: null
      },
      payment: {
        enabled: false,
        code: null
      },
      sum: {
        enabled: false,
        sumBegin: null,
        sumEnd: null
      },
      showSpaced: {
        enabled: false
      }
    });
    this.$store.commit("setParams", null);
    this.$store.commit("clearPacksReceipts");
    this.$store.commit("clearInfoReceipts");
    this.$store.commit("clearStatusModifyPacksReceipts");
    this.$store.commit("clearImportTypes");
    this.$store.commit("clearImportFiles");
    this.$store.commit("clearImportFilesBuffer");
    this.$store.commit("clearStatusAddCodeplat");
    this.$store.commit("clearStatusLoadPackFile");
    this.$store.commit("clearStatusLoadPackFileCheck");
    this.$store.commit("clearStatusImportFileCodeFirme");

    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions(["getParams"]),
    onAddBtn() {
      this.statusModify = "add";
      this.editModal = true;
    },
    onEditBtn() {
      this.statusModify = "edit";
      this.editModal = true;
    },
    onDeleteBtn() {
      this.statusModify = "delete";
      this.confirmDelete("4");
    },
    onPostingBtn() {
      let { npack, summa, namefirme } = this.currentPacksReceiptsRowSelected;
      npack = npack.trim();

      this.postingModal = true;
      this.$confirm(
        `${this.$t(
          "packsreceipts.postingBtn.confirm.postingPack"
        )} ${npack} ${this.$t(
          "packsreceipts.postingBtn.confirm.summaPack"
        )} ${summa}, ${this.$t(
          "packsreceipts.postingBtn.confirm.senderPack"
        )} ${namefirme}?`,
        this.$t("packsreceipts.postingBtn.confirm.title"),
        {
          confirmButtonText: this.$t("common.buttons.confirmYes"),
          cancelButtonText: this.$t("common.buttons.confirmNo"),
          cancelButtonClass: "cancel-button",
          type: "warning"
        }
      )
        .then(() => {
          this.postingModal = false;
          this.$store.commit("clearStatusInfoPack");
          this.$store.dispatch("receiptsInfoPack", { npack });
        })
        .catch(() => {
          this.postingModal = false;
        });
    },
    onDeletedPacksBtn() {
      this.typeInfoModal = false;
      this.infoModal = true;
    },
    onIndefiniteReceiptsBtn() {
      this.typeInfoModal = true;
      this.infoModal = true;
    },
    onImportPaymentsBtn() {
      this.typeImport = "1";
      this.importModal = true;
    },
    onImportSubsidiesBtn() {
      this.typeImport = "0";
      this.importModal = true;
    },
    onAddImportFileBtn() {
      if (this.importBtnVisible) {
        this.importFormStatus = "1";

        this.$refs.importForm.validate(valid => {
          if (valid) {
            this.uploadFilesModal = true;
          }
        });
      } else {
        this.$alert(
          this.$t("packsreceipts.importFiles.denyChangeListFiles"),
          this.$t("packsreceipts.importFiles.alert.title"),
          {
            confirmButtonText: this.$t("common.buttons.confirmOk"),
            type: "warning"
          }
        );
      }
    },
    onDeleteImportFileBtn() {
      if (this.importBtnVisible) {
        const payload = this.currentImportFilesRowSelected;
        this.$store.commit("removeImportFile", payload);
      } else {
        this.$alert(
          this.$t("packsreceipts.importFiles.denyChangeListFiles"),
          this.$t("packsreceipts.importFiles.alert.title"),
          {
            confirmButtonText: this.$t("common.buttons.confirmOk"),
            type: "warning"
          }
        );
      }
    },
    onChangeMfo(value) {
      if (value) {
        const gfirme = this.params.gfirme.data.filter(
          item => item.mfo === value
        );
        if (gfirme.length > 0 && this.editForm.datebank) {
          this.editForm.codefirme = gfirme[0].codefirme;
        }
      } else {
        this.editForm.codefirme = null;
      }
    },
    onGridSizeChanged(params) {
      // params.api.sizeColumnsToFit();
    },
    onPacksReceiptsGridReady(params) {
      this.packsReceiptsGridApi = params.api;
      this.packsReceiptsColumnApi = params.columnApi;
    },
    onPacksReceiptsFirstDataRendered(event) {
      setGridView("wb-packsreceipts-grid-packsreceipts", event, "optimal");
    },
    onPacksReceiptsRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-packsreceipts-grid-packsreceipts"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onPacksReceiptsRowSelected(params) {
      if (params.node.selected) {
        params.api.ensureIndexVisible(params.node.rowIndex);

        this.currentPacksReceiptsRowSelected = params.node.data;

        const {
          status,
          isimport,
          kindpay
        } = this.currentPacksReceiptsRowSelected;
        this.editBtnDisabled = status !== "2" ? false : true;
        this.postingBtnDisabled =
          isimport === "1" && kindpay === "99" ? false : true;
      }
    },
    onPacksReceiptsModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();
      this.filterType = rowCount >= 100 ? "danger" : "primary";

      const btnDisabled = rowCount === 0 ? true : false;
      this.editBtnDisabled = btnDisabled;
      this.deleteBtnDisabled = btnDisabled;
      this.extraBtnDisabled = btnDisabled;
      this.postingBtnDisabled = btnDisabled;

      params.api.forEachNode(node => {
        if (this.lastRow) {
          node.setSelected(node.data.npack === this.lastRow);
        } else {
          node.rowIndex ? 0 : node.setSelected(true);
        }
      });

      let pinnedRowCountband = 0;
      let pinnedRowQuantity = 0;
      let pinnedRowSumma = 0;

      for (let i = 0; i < rowCount; i++) {
        let rowNode = params.api.getDisplayedRowAtIndex(i);
        if (rowNode.data.countband !== "") {
          pinnedRowCountband = $(pinnedRowCountband)
            .add($(rowNode.data.countband))
            .toNumber();
        }
        pinnedRowQuantity = $(pinnedRowQuantity)
          .add($(rowNode.data.quantity))
          .toNumber();
        pinnedRowSumma = $(pinnedRowSumma)
          .add($(rowNode.data.summa))
          .toNumber();
      }
      pinnedRowSumma = formatSum($(pinnedRowSumma).toFixed());

      try {
        this.packsReceiptsPinnedBottomRowData = [
          {
            npack: "",
            namefirme: "",
            datebank: "",
            kindname: "",
            countband: pinnedRowCountband,
            quantity: pinnedRowQuantity,
            summa: pinnedRowSumma,
            sumprof: "",
            isimport: ""
          }
        ];
      } catch {
        this.packsReceiptsPinnedBottomRowData = [
          {
            npack: "",
            namefirme: "",
            datebank: "",
            kindname: "",
            countband: "0",
            quantity: "0",
            summa: "0.00",
            sumprof: "",
            isimport: ""
          }
        ];
      }
    },
    onInfoReceiptsGridReady(params) {
      this.infoReceiptsGridApi = params.api;
      this.infoReceiptsColumnApi = params.columnApi;

      params.api.setRowData([]);
      params.api.showLoadingOverlay();
    },
    onInfoReceiptsFirstDataRendered(event) {
      setGridView(this.sourceInfoKey, event, "optimal");
    },
    onInfoReceiptsRowRightClicked(event) {
      this.$store.commit("setGridContextMenuKey", this.sourceInfoKey);
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onInfoReceiptsModelUpdated(params) {
      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
    },
    onImportFilesGridReady(params) {
      this.importFilesGridApi = params.api;
      this.importFilesColumnApi = params.columnApi;
    },
    onImportFilesFirstDataRendered(event) {
      setGridView("wb-packsreceipts-grid-importfiles", event, "optimal");
    },
    onImportFilesRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-packsreceipts-grid-importfiles"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onImportFilesRowSelected(params) {
      if (params.node.selected) {
        this.currentImportFilesRowSelected = params.node.data;

        const {
          status,
          impFile,
          countpack,
          datapack,
          errmess,
          kompack,
          sender,
          summapack
        } = this.currentImportFilesRowSelected;
        let msg = "";

        if (status === "1") {
          if (errmess) {
            msg += errmess;
          } else {
            msg += `${this.$t("packsreceipts.importFiles.error")} ${impFile}`;
          }
        } else {
          if (errmess) {
            msg += errmess;
          } else {
            msg += `${this.$t(
              "packsreceipts.importFiles.sender"
            )}: ${sender}\n`;
            msg += `${this.$t(
              "packsreceipts.importFiles.datapack"
            )}: ${datapack}\n`;
            msg += `${this.$t(
              "packsreceipts.importFiles.countpack"
            )}: ${countpack}\n`;
            msg += `${this.$t(
              "packsreceipts.importFiles.summapack"
            )}: ${formatSum($(summapack).toFixed())}\n`;
            msg += `${this.$t(
              "packsreceipts.importFiles.kompack"
            )}: ${formatSum($(kompack).toFixed())}`;
          }
        }
        this.importForm.fileinfo = msg;
      }
    },
    onImportFilesModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();

      this.deleteImportFileBtnDisabled = rowCount === 0 ? true : false;
      this.addImportFileBtnDisabled =
        !this.multiupload && rowCount >= 1 ? true : false;

      params.api.forEachNode(node => {
        node.rowIndex ? 0 : node.setSelected(true);
      });

      if (rowCount === 0) {
        this.importForm.fileinfo = "";
      }
    },
    getPacksReceipts() {
      if (this.packsReceiptsGridOptions.api) {
        this.packsReceiptsGridOptions.api.setRowData([]);
        this.packsReceiptsGridOptions.api.showLoadingOverlay();
      }
      this.$store.dispatch("getPacksReceipts");
    },
    // getImportFiles() {
    //   const serverfolder = this.uploadServerFolder;
    //   if (this.importFilesGridOptions.api) {
    //     this.importFilesGridOptions.api.setRowData([]);
    //     this.importFilesGridOptions.api.showLoadingOverlay();
    //   }
    //   this.$store.commit("setStatusImportFiles", false);
    //   this.$store.dispatch("listUploadDir", { serverfolder });
    // },
    confirmAdd(confirm) {
      const {
        packnumber,
        datebank,
        codefirme,
        countband,
        kindpay,
        summa,
        sumprof,
        quantity,
        isimport,
        userid
      } = this.editForm;

      const behavior = "2";
      const checkSumprof = ["88", "91", "99"].includes(kindpay) ? 0 : sumprof;

      this.$store.commit("clearStatusModifyPacksReceipts");
      this.$store.dispatch("packsReceiptsAdd", {
        behavior,
        packnumber,
        datebank,
        codefirme,
        countband,
        kindpay,
        summa: summa ? $(summa).toFixed() : "0",
        sumprof: checkSumprof ? $(checkSumprof).toFixed() : "0",
        quantity,
        isimport,
        userid,
        confirm
      });
    },
    confirmEdit(confirm) {
      const {
        packnumber,
        datebank,
        codefirme,
        countband,
        kindpay,
        summa,
        sumprof,
        paysheetid,
        quantity,
        npack,
        isimport,
        userid,
        datebeginfact
      } = this.editForm;

      const behavior = "3";
      const checkSumprof = ["88", "91", "99"].includes(kindpay) ? 0 : sumprof;

      this.$store.commit("clearStatusModifyPacksReceipts");
      this.$store.dispatch("packsReceiptsEdit", {
        behavior,
        packnumber,
        datebank,
        codefirme,
        countband,
        kindpay,
        summa: summa ? $(summa).toFixed() : "",
        sumprof: checkSumprof ? $(checkSumprof).toFixed() : "",
        paysheetid,
        quantity,
        npack,
        isimport,
        userid,
        datebeginfact,
        confirm
      });
    },
    confirmDelete(behavior) {
      const {
        npack,
        status,
        kindpay,
        datebank,
        summa,
        codefirme,
        datebeginfact
      } = this.currentPacksReceiptsRowSelected;

      this.$store.commit("clearStatusModifyPacksReceipts");
      this.$store.dispatch("packsReceiptsDelete", {
        behavior,
        npack,
        status,
        kindpay,
        datebank,
        summa,
        codefirme,
        datebeginfact
      });
    },
    checkImportFiles() {
      const totalImportFilesRows = this.importFilesBuffer.length;

      if (this.importFilesCurrentRow < totalImportFilesRows) {
        const status = this.importFilesBuffer[this.importFilesCurrentRow]
          .status;
        if (status === "1") {
          this.importFilesCurrentRow += 1;
          this.checkImportFiles();
        } else {
          const codepage = this.importExtProp.codepage;
          const codeimport = this.importForm.codeimport;
          const kindpay = this.importForm.kindpay;
          const subs = this.typeImport;
          const fin = this.importFilesBuffer[this.importFilesCurrentRow]
            .reeName;
          const fip = this.importFilesBuffer[this.importFilesCurrentRow]
            .reePath;

          // !this.importExtProp.codeplat - особый случай импорта платежей как субсидий, диалог
          if (subs === "1" && !this.importExtProp.codeplat) {
            this.$store.dispatch("checkImportFileCodeFirme", {
              codeimport,
              codepage,
              kindpay,
              subs,
              fin,
              fip
            });
          } else {
            this.confirmSenderModal = true;
          }
        }
      } else {
        this.$store.commit("setImportFiles", this.importFilesBuffer);
        this.$store.commit("clearImportFilesBuffer");
      }
    },
    processingImportFiles() {
      const totalImportFilesRows = this.importFiles.length;

      if (this.importFilesProcessingCurrentRow < totalImportFilesRows) {
        const { status, processed, errmess } = this.importFiles[
          this.importFilesProcessingCurrentRow
        ];

        if (status === "1" || processed === "1" || errmess !== "") {
          this.importFilesProcessingCurrentRow += 1;
          this.processingImportFiles();
        } else {
          this.processingImportOneFile();
        }
      } else {
        const processedImportFiles = this.importFiles.filter(
          item => item.processed === "1"
        );

        this.$alert(
          this.$t("packsreceipts.importFiles.importedFiles", {
            files: processedImportFiles.length
          }),
          this.$t("packsreceipts.importFiles.alert.title"),
          {
            confirmButtonText: this.$t("common.buttons.confirmOk"),
            type: "info"
          }
        );

        this.importBtnVisible = false;
        this.reportBtnVisible = true;
      }
    },
    processingImportOneFile() {
      this.bankcodeplatResult = [];
      this.bankcodeplatOriginal = this.importFiles[
        this.importFilesProcessingCurrentRow
      ].bankcodeplat;

      this.cfilResult = [];
      this.cfilOriginal = this.importFiles[
        this.importFilesProcessingCurrentRow
      ].cfil;

      // check bankcodeplat
      if (
        Array.isArray(this.bankcodeplatOriginal) &&
        this.bankcodeplatOriginal.length
      ) {
        this.bankcodeplatProcessingCurrentRow = 0;
        this.linkDestination();
        // check cfil
      } else if (Array.isArray(this.cfilOriginal) && this.cfilOriginal.length) {
        this.cfilProcessingCurrentRow = 0;
        this.linkSender();
      } else {
        this.executingImportOneFile();
      }
    },
    linkDestination() {
      if (
        this.bankcodeplatProcessingCurrentRow <
          this.bankcodeplatOriginal.length &&
        !this.importForm.codepay
      ) {
        const { namebankcodeplat, bankcodeplat } = this.bankcodeplatOriginal[
          this.bankcodeplatProcessingCurrentRow
        ];
        this.confirmDestLinkForm.status = null;
        this.confirmDestLinkForm.namebankcodeplat = namebankcodeplat;
        this.confirmDestLinkForm.bankcodeplat = bankcodeplat;
        this.confirmDestLinkForm.codeplat = null;
        this.confirmDestLinkForm.withvalue = false;

        this.confirmDestLinkModal = true;
      } else {
        // check cfil
        if (Array.isArray(this.cfilOriginal) && this.cfilOriginal.length) {
          this.cfilProcessingCurrentRow = 0;
          this.linkSender();
        } else {
          this.executingImportOneFile();
        }
      }
    },
    linkSender() {
      if (this.cfilProcessingCurrentRow < this.cfilOriginal.length) {
        this.confirmSenderMfoNumberForm.status = null;
        this.confirmSenderMfoNumberForm.mfo = this.cfilOriginal[
          this.cfilProcessingCurrentRow
        ].mfo;
        this.confirmSenderMfoNumberForm.number = this.cfilOriginal[
          this.cfilProcessingCurrentRow
        ].c_fil_old;

        this.confirmSenderMfoNumberModal = true;
      } else {
        this.executingImportOneFile();
      }
    },
    executingImportOneFile() {
      const codeimport = this.importForm.codeimport;
      const kindpay = this.importForm.kindpay;
      const codeplat = this.importForm.codepay || "";
      const subs = this.typeImport;
      const fin = this.importFiles[this.importFilesProcessingCurrentRow]
        .reeName;
      const fip = this.importFiles[this.importFilesProcessingCurrentRow]
        .reePath;
      const codefirme = this.importFiles[this.importFilesProcessingCurrentRow]
        .codefirme;
      const datapack = this.importFiles[this.importFilesProcessingCurrentRow]
        .datapack;
      const codepage = this.importExtProp.codepage;

      this.$store.commit("clearStatusLoadPackFile");
      this.$store.dispatch("loadPackFile", {
        codeimport,
        codefirme,
        codepage,
        kindpay,
        codeplat,
        subs,
        fin,
        fip,
        datapack,
        bankcodeplat: this.bankcodeplatResult,
        cfil: this.cfilResult
      });
    },
    completedImportOneFile() {
      const { impFile } = this.importFiles[
        this.importFilesProcessingCurrentRow
      ];
      const payload = {
        impFile
      };
      this.$store.commit("setCompletedImportFile", payload);

      this.importFilesProcessingCurrentRow =
        this.importFilesProcessingCurrentRow + 1;
      this.processingImportFiles();
    },
    errorImportOneFile(errmess) {
      const { impFile } = this.importFiles[
        this.importFilesProcessingCurrentRow
      ];
      const payload = {
        impFile,
        errmess
      };
      this.$store.commit("setErrorImportFile", payload);

      this.importFilesProcessingCurrentRow =
        this.importFilesProcessingCurrentRow + 1;
      this.processingImportFiles();
    },
    filterModalShow() {
      const dateBegin = this.packsReceiptsFilter.period.dateBegin;
      const dateEnd = this.packsReceiptsFilter.period.dateEnd;
      this.filterForm = {
        dateEnabled: this.packsReceiptsFilter.period.enabled,
        dateRange: [dateBegin, dateEnd],
        organizationEnabled: this.packsReceiptsFilter.organization.enabled,
        organizationCode: this.packsReceiptsFilter.organization.code,
        paymentEnabled: this.packsReceiptsFilter.payment.enabled,
        paymentCode: this.packsReceiptsFilter.payment.code,
        sumEnabled: this.packsReceiptsFilter.sum.enabled,
        sumBegin: $(this.packsReceiptsFilter.sum.sumBegin).toNumber(),
        sumEnd: $(this.packsReceiptsFilter.sum.sumEnd).toNumber(),
        showSpacedEnabled: this.packsReceiptsFilter.showSpaced.enabled
      };
    },
    filterModalHide() {
      this.filterForm = {
        dateEnabled: null,
        dateRange: [],
        organizationEnabled: null,
        organizationCode: null,
        paymentEnabled: null,
        paymentCode: null,
        sumEnabled: null,
        sumBegin: 0,
        sumEnd: 0,
        showSpacedEnabled: null
      };
      this.$refs.filterForm.resetFields();
    },
    filterModalSubmit() {
      this.$refs.filterForm.validate(valid => {
        if (valid) {
          const filter = {
            period: {
              enabled: this.filterForm.dateEnabled,
              dateBegin: this.filterForm.dateRange[0],
              dateEnd: this.filterForm.dateRange[1]
            },
            organization: {
              enabled: this.filterForm.organizationEnabled,
              code: this.filterForm.organizationCode
            },
            payment: {
              enabled: this.filterForm.paymentEnabled,
              code: this.filterForm.paymentCode
            },
            sum: {
              enabled: this.filterForm.sumEnabled,
              sumBegin: this.filterForm.sumBegin
                ? $(this.filterForm.sumBegin).toFixed()
                : "0.00",
              sumEnd: this.filterForm.sumEnd
                ? $(this.filterForm.sumEnd).toFixed()
                : "0.00"
            },
            showSpaced: {
              enabled: this.filterForm.showSpacedEnabled
            }
          };

          this.$localStorage.set(
            "wb-packsreceipts-filter",
            JSON.stringify(filter)
          );
          this.$store.commit("setPacksReceiptsFilter", filter);
          this.filterModal = false;

          this.lastRow = null;
          this.getPacksReceipts();
        }
      });
    },
    infoModalShow() {
      if (this.infoReceiptsGridOptions.api) {
        this.infoReceiptsGridOptions.api.setRowData([]);
        this.infoReceiptsGridOptions.api.showLoadingOverlay();
      }
      if (this.typeInfoModal) {
        this.titleInfoModal = this.$t(
          "packsreceipts.info.modal.title.vagueReadings"
        );
        this.sourceInfoModal = this.indefiniteReceiptsColumnDefs;
        this.sourceInfoKey = "wb-packsreceipts-grid-indefinitereceipts";

        const { npack } = this.currentPacksReceiptsRowSelected;

        this.$store.dispatch("getIndefiniteReceipts", { npack });
      } else {
        this.titleInfoModal = `${this.$t(
          "packsreceipts.info.modal.title.deletedPacksPeriodWith"
        )} ${this.packsReceiptsFilter.period.dateBegin} ${this.$t(
          "packsreceipts.info.modal.title.deletedPacksPeriodBy"
        )} ${this.packsReceiptsFilter.period.dateEnd}`;
        this.sourceInfoModal = this.deletedPacksColumnDefs;
        this.sourceInfoKey = "wb-packsreceipts-grid-deletedpacks";

        this.$store.dispatch("getDeletedPacks");
      }
    },
    infoModalHide() {
      this.typeInfoModal = null;
      this.titleInfoModal = "";
      this.sourceInfoModal = null;
      this.sourceInfoKey = "";
      this.$store.commit("clearInfoReceipts");
    },
    editModalShow() {
      this.visibleSumprof = true;
      this.visibleOperator = false;
      this.titleEditModal = this.$t(
        "packsreceipts.editForm.modal.title.packageInfo"
      );
      this.labelQuantity = this.$t(
        "packsreceipts.editForm.form.quantity.numberReceipts"
      );
      this.labelCountband = this.$t(
        "packsreceipts.editForm.form.countband.numberCountband"
      );

      if (this.statusModify === "add") {
        this.editForm = {
          isimport: "0",
          packnumber: "",
          datebank: "",
          mfo: "",
          codefirmeCode: null,
          codefirme: null,
          senders: [],
          accountSender: "",
          kindpayCode: null,
          kindpay: null,
          quantity: 1,
          countband: 1,
          summa: 0,
          sumprof: 0,
          paysheetid: null,
          datebeginfact: null,
          useridCode: this.user.userid.toString(),
          userid: this.user.userid.toString()
        };
      } else if (this.statusModify === "edit") {
        const {
          isimport,
          packnumber,
          datebank,
          codefirme,
          kindpay,
          quantity,
          countband,
          summa,
          sumprof,
          paysheetid,
          datebeginfact,
          npack,
          userid
        } = this.currentPacksReceiptsRowSelected;
        this.editForm = {
          isimport,
          packnumber,
          datebank,
          quantity,
          mfo: "",
          codefirme,
          senders: [],
          accountSender: "",
          kindpay,
          countband,
          summa: $(summa).toNumber(),
          sumprof: $(sumprof).toNumber(),
          paysheetid,
          datebeginfact,
          npack,
          userid
        };
      }
      this.editForm.payments = this.params.gkindpay.data.filter(
        item =>
          !["50", "90", "97", "98", "100"].includes(item.kindpay) &&
          item.used === "1"
      );
      this.editFieldDisabled =
        this.editForm.isimport === "1" || this.editForm.status === "2"
          ? true
          : false;
    },
    editModalHide() {
      this.statusModify = null;
      this.statusInsert = null;
      this.editForm = {
        isimport: null,
        packnumber: null,
        datebank: null,
        mfo: null,
        codefirmeCode: null,
        codefirme: null,
        senders: [],
        accountSender: null,
        kindpayCode: null,
        kindpay: null,
        payments: [],
        quantity: null,
        countband: null,
        summa: 0,
        sumprof: 0,
        paysheetid: null,
        datebeginfact: null,
        npack: null,
        useridCode: null,
        userid: null
      };
      this.$refs.editForm.resetFields();
    },
    callConfirmAdd(statusInsert) {
      this.statusInsert = statusInsert;
      this.confirmAdd("");
    },
    checkStatusModify() {
      if (this.statusModify === "add") {
        this.callConfirmAdd(false);
      } else if (this.statusModify === "edit") {
        this.statusInsert = false;
        this.confirmEdit("");
      }
    },
    insertModalSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (this.editForm.quantity === 1) {
            this.$confirm(
              this.$t("packsreceipts.editForm.form.addPayment"),
              "",
              {
                confirmButtonText: this.$t("common.buttons.confirmYes"),
                cancelButtonText: this.$t("common.buttons.confirmNo"),
                cancelButtonClass: "cancel-button",
                type: "info"
              }
            )
              .then(() => {
                this.statusPayment = true;
                this.callConfirmAdd(true);
              })
              .catch(() => {
                this.statusPayment = false;
                this.callConfirmAdd(true);
              });
          } else {
            this.statusPayment = false;
            this.callConfirmAdd(true);
          }
        }
      });
    },
    editModalSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (this.statusModify === "add" && this.editForm.quantity === 1) {
            this.$confirm(
              this.$t("packsreceipts.editForm.form.addPayment"),
              "",
              {
                confirmButtonText: this.$t("common.buttons.confirmYes"),
                cancelButtonText: this.$t("common.buttons.confirmNo"),
                cancelButtonClass: "cancel-button",
                type: "info"
              }
            )
              .then(() => {
                this.statusPayment = true;
                this.checkStatusModify();
              })
              .catch(() => {
                this.statusPayment = false;
                this.checkStatusModify();
              });
          } else {
            this.statusPayment = false;
            this.checkStatusModify();
          }
        }
      });
    },
    importModalShow() {
      this.titleImportModal =
        this.typeImport === "1"
          ? this.$t("packsreceipts.import.modal.title.payments")
          : this.$t("packsreceipts.import.modal.title.subsidies");

      this.importBtnVisible = true;
      this.reportBtnVisible = false;

      const typeimport = this.typeImport;
      this.$store.dispatch("getImportTypes", { typeimport });

      if (this.typeImport === "1") {
        this.importForm.payments = this.params.gkindpay.data.filter(
          item =>
            item.used === "1" &&
            !["50", "90", "97", "98", "99", "100"].includes(item.kindpay)
        );
      } else {
        this.importForm.payments = this.params.gkindpay.data.filter(
          item => item.used === "1" && ["99"].includes(item.kindpay)
        );
      }

      const importLocalStorage = this.$localStorage.get(
        "wb-packsreceipts-import"
      );
      if (importLocalStorage) {
        const session = JSON.parse(importLocalStorage);
        if (session.codepayEnabled) {
          this.importForm.codepayEnabled = session.codepayEnabled;
        } else {
          this.importForm.codepayEnabled = false;
        }
      } else {
        this.importForm.codepayEnabled = false;
      }

      this.uploadServerFolder = this.$uuid.v4();
    },
    importModalHide() {
      const importLocalStorage = {
        codepayEnabled: this.importForm.codepayEnabled
      };
      this.$localStorage.set(
        "wb-packsreceipts-import",
        JSON.stringify(importLocalStorage)
      );

      this.typeImport = null;
      this.titleImportModal = "";
      this.importFormStatus = null;
      this.importForm = {
        codeimportCode: null,
        codeimport: null,
        codeimportDisabled: false,
        kindpayCode: null,
        kindpay: null,
        kindpayDisabled: false,
        fileinfo: "",
        payments: [],
        codepayCode: null,
        codepay: null,
        codepayEnabled: false,
        codepayRadio: "file"
      };
      this.$refs.importForm.resetFields();

      this.addImportFileBtnDisabled = false;
      this.deleteImportFileBtnDisabled = true;

      const serverfolder = this.uploadServerFolder;
      this.$store.dispatch("removeUploadDir", { serverfolder });

      const completedImportFiles = this.importFiles.filter(
        item => item.processed === "1"
      );
      if (completedImportFiles.length > 0) {
        this.getPacksReceipts();
      }

      this.$refs.importFormInfo.scrollTo(0, 0);

      this.$store.commit("clearImportTypes");
      this.$store.commit("clearImportFiles");
      this.$store.commit("clearImportFilesBuffer");
      this.$store.commit("clearStatusAddCodeplat");
      this.$store.commit("clearStatusLoadPackFile");
      this.$store.commit("clearStatusLoadPackFileCheck");
    },
    importModalSubmit() {
      this.importFormStatus = "0";

      this.$refs.importForm.validate(valid => {
        if (valid) {
          const checkimportFiles = this.importFiles.filter(
            item => item.status === "0" && item.processed === "0"
          );
          if (checkimportFiles.length > 0) {
            this.importFilesProcessingCurrentRow = 0;
            this.processingImportFiles();
          } else {
            this.$alert(
              this.$t("packsreceipts.importFiles.noAvailableImportFiles"),
              this.$t("packsreceipts.importFiles.alert.title"),
              {
                confirmButtonText: this.$t("common.buttons.confirmOk"),
                type: "warning"
              }
            );
          }
        }
      });
    },
    importModalReport() {
      let txtContent = "data:text/plain;charset=utf-8,";
      this.importFiles.forEach(item => {
        const result =
          item.processed === "1"
            ? this.$t("packsreceipts.import.result.success")
            : `${this.$t("packsreceipts.import.result.error")}: ${
                item.errmess
              }`;
        txtContent += `${item.impFile}\t${result}\r\n`;
      });

      const encodedUri = encodeURI(txtContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "report.txt");
      document.body.appendChild(link);
      link.click();
    },
    uploadFilesModalHide() {
      this.fileMask = "";
      this.$refs.upload.clearFiles();
    },
    uploadFilesSubmit() {
      this.$refs.uploadForm.validate(valid => {
        if (valid) {
          const files = this.$refs.upload.uploadFiles;
          const serverfolder = this.uploadServerFolder;
          const typeimport = this.typeImport;
          const codeimport = this.importForm.codeimport;

          this.$store.commit("clearImportFilesBuffer");
          this.$store.dispatch("uploadFiles", {
            serverfolder,
            typeimport,
            codeimport,
            files
          });
        }
      });
    },
    confirmSenderModalShow() {
      this.confirmSenderForm.fileName = this.importFilesBuffer[
        this.importFilesCurrentRow
      ].reeName;
      this.confirmSenderForm.codefirme = this.params.gfirme.data[0].codefirme;
    },
    confirmSenderModalHide() {
      const codepage = this.importExtProp.codepage;
      const codeimport = this.importForm.codeimport;
      const kindpay = this.importForm.kindpay;
      const subs = this.typeImport;
      const codefirme =
        this.confirmSenderForm.status === "1"
          ? this.confirmSenderForm.codefirme
          : "0";

      const fin = this.importFilesBuffer[this.importFilesCurrentRow].reeName;
      const fip = this.importFilesBuffer[this.importFilesCurrentRow].reePath;

      this.confirmSenderForm = {
        fileName: "",
        codefirmeCode: null,
        codefirme: null,
        status: "0"
      };
      this.$refs.confirmSenderForm.resetFields();

      this.$store.commit("setStatusInfoImportFile", false);
      this.$store.dispatch("getFileInfo", {
        codeimport,
        codefirme,
        codepage,
        kindpay,
        subs,
        fin,
        fip
      });
    },
    confirmSenderSubmit() {
      this.$refs.confirmSenderForm.validate(valid => {
        if (valid) {
          this.confirmSenderForm.status = "1";
          this.confirmSenderModal = false;
        }
      });
    },
    confirmSenderCancel() {
      this.confirmSenderForm.status = "0";
      this.confirmSenderModal = false;
    },
    confirmSenderMfoModalShow() {
      this.confirmSenderMfoForm = {
        mfo: this.statusImportFileCodeFirme.mfo,
        senders: this.statusImportFileCodeFirme.data,
        codefirme: this.statusImportFileCodeFirme.data[0].codefirme,
        selectCodefirme: "0"
      };
    },
    confirmSenderMfoModalHide() {
      const codefirme = this.confirmSenderMfoForm.selectCodefirme;

      this.confirmSenderMfoForm = {
        mfo: "",
        senders: [],
        codefirmeCode: null,
        codefirme: null,
        selectCodefirme: "0"
      };
      this.$store.commit("clearStatusImportFileCodeFirme");

      const codepage = this.importExtProp.codepage;
      const codeimport = this.importForm.codeimport;
      const kindpay = this.importForm.kindpay;
      const subs = this.typeImport;
      const fin = this.importFilesBuffer[this.importFilesCurrentRow].reeName;
      const fip = this.importFilesBuffer[this.importFilesCurrentRow].reePath;

      this.$store.commit("setStatusInfoImportFile", false);
      this.$store.dispatch("getFileInfo", {
        codeimport,
        codefirme,
        codepage,
        kindpay,
        subs,
        fin,
        fip
      });
    },
    confirmSenderMfoSubmit() {
      this.$refs.confirmSenderMfoForm.validate(valid => {
        if (valid) {
          this.confirmSenderMfoForm.selectCodefirme = this.confirmSenderMfoForm.codefirme;
          this.confirmSenderMfoModal = false;
        }
      });
    },
    confirmSenderMfoCancel() {
      this.confirmSenderMfoModal = false;
    },
    confirmDestLinkModalHide() {
      const {
        status,
        bankcodeplat,
        codeplat,
        withvalue
      } = this.confirmDestLinkForm;

      this.confirmDestLinkForm = {
        status: null,
        namebankcodeplat: "",
        bankcodeplat: null,
        codeplat: null,
        withvalue: false
      };
      this.$refs.confirmDestLinkForm.resetFields();

      if (status === "1") {
        const bankcodeplatTransform = {
          bankcodeplat,
          codeplat,
          withvalue: withvalue ? "1" : "0"
        };
        this.bankcodeplatResult.push(bankcodeplatTransform);
        this.bankcodeplatProcessingCurrentRow =
          this.bankcodeplatProcessingCurrentRow + 1;
        this.linkDestination();
      } else {
        const errmess = this.$t("packsreceipts.confirmDestLink.importError");
        const { impFile } = this.importFiles[
          this.importFilesProcessingCurrentRow
        ];
        const payload = {
          impFile,
          errmess
        };
        this.$store.commit("setErrorImportFile", payload);

        this.importFilesProcessingCurrentRow =
          this.importFilesProcessingCurrentRow + 1;
        this.processingImportFiles();
      }
    },
    confirmDestLinkSubmit() {
      this.$refs.confirmDestLinkForm.validate(valid => {
        if (valid) {
          this.confirmDestLinkForm.status = "1";
          this.confirmDestLinkModal = false;
        }
      });
    },
    confirmDestLinkCancel() {
      this.confirmDestLinkForm.status = "0";
      this.confirmDestLinkModal = false;
    },
    confirmDateBankModalShow() {
      this.confirmDateBankForm.dateBank = this.importFilesBuffer[
        this.importFilesCurrentRow
      ].datapack;
    },
    confirmDateBankModalHide() {
      if (this.confirmDateBankForm.status === "1") {
        this.importFilesBuffer[
          this.importFilesCurrentRow
        ].datapack = this.confirmDateBankForm.dateBank;
      } else {
        this.importFilesBuffer[this.importFilesCurrentRow].errmess = this.$t(
          "packsreceipts.confirmDateBank.importError"
        );
        this.importFilesBuffer[this.importFilesCurrentRow].processed = "0";
        this.importFilesBuffer[this.importFilesCurrentRow].status = "1";
      }

      this.confirmDateBankForm.dateBank = "";
      this.confirmDateBankForm.status = "0";

      this.importFilesCurrentRow += 1;
      this.checkImportFiles();
    },
    confirmDateBankSubmit() {
      this.$refs.confirmDateBankForm.validate(valid => {
        if (valid) {
          this.confirmDateBankForm.status = "1";
          this.confirmDateBankModal = false;
        }
      });
    },
    confirmDateBankCancel() {
      this.confirmDateBankForm.status = "0";
      this.confirmDateBankModal = false;
    },
    confirmSenderMfoNumberModalShow() {
      this.confirmSenderMfoNumberForm.firms = this.params.gfirme.data.filter(
        item => item.mfo === this.confirmSenderMfoNumberForm.mfo // && item.number !== "" - уточнение от 10.11.2021
      );
    },
    confirmSenderMfoNumberModalHide() {
      const {
        status,
        mfo,
        number,
        codefirme
      } = this.confirmSenderMfoNumberForm;

      this.confirmSenderMfoNumberForm = {
        status: null,
        mfo: "",
        number: "",
        codefirmeCode: null,
        codefirme: null,
        firms: []
      };
      this.$refs.confirmSenderMfoNumberForm.resetFields();

      if (status === "1") {
        const firme = this.params.gfirme.data.filter(
          item => item.codefirme === codefirme
        );

        const cfilTransform = {
          codefirme_new: codefirme,
          c_fil_new: firme[0].number,
          c_fil_old: number,
          mfo
        };
        this.cfilResult.push(cfilTransform);
        this.cfilProcessingCurrentRow += 1;
        this.linkSender();
      } else {
        const errmess = this.$t(
          "packsreceipts.confirmSenderMfoNumber.importError"
        );
        const { impFile } = this.importFiles[
          this.importFilesProcessingCurrentRow
        ];
        const payload = {
          impFile,
          errmess
        };
        this.$store.commit("setErrorImportFile", payload);
        this.importFilesProcessingCurrentRow += 1;
        this.processingImportFiles();
      }
    },
    confirmSenderMfoNumberSubmit() {
      this.$refs.confirmSenderMfoNumberForm.validate(valid => {
        if (valid) {
          this.confirmSenderMfoNumberForm.status = "1";
          this.confirmSenderMfoNumberModal = false;
        }
      });
    },
    confirmSenderMfoNumberCancel() {
      this.confirmSenderMfoNumberForm.status = "0";
      this.confirmSenderMfoNumberModal = false;
    },
    onChangeKindpayCode(event) {
      const value = event.target.value;
      const kindpays = this.editForm.payments.filter(
        item => item.kindpay === value
      );
      if (kindpays.length > 0) {
        this.editForm.kindpay = value;
      } else {
        this.editForm.kindpay = null;
        this.editForm.kindpayCode = null;
      }
    },
    onChangeImportKindpayCode(event) {
      const value = event.target.value;
      const kindpays = this.importForm.payments.filter(
        item => item.kindpay === value
      );
      if (kindpays.length > 0) {
        this.importForm.kindpay = value;
      } else {
        this.importForm.kindpay = null;
        this.importForm.kindpayCode = null;
      }
    },
    onChangeUseridCode(event) {
      const value = event.target.value;
      const users = this.params.guserspackedit.data.filter(
        item => item.userid === value
      );
      if (users.length > 0) {
        this.editForm.userid = value;
      } else {
        this.editForm.userid = null;
        this.editForm.useridCode = null;
      }
    },
    onChangeCodefirmeCode(event) {
      const value = event.target.value;
      const codefirmes = this.editForm.senders.filter(
        item => item.codefirme === value
      );
      if (codefirmes.length > 0) {
        this.editForm.codefirme = value;
      } else {
        this.editForm.codefirme = null;
        this.editForm.codefirmeCode = null;
      }
    },
    onChangeImportCodepayCode(event) {
      const value = event.target.value;
      const codepays = this.params.codepay.data.filter(
        item => item.codeplat === value
      );
      if (codepays.length > 0) {
        this.importForm.codepay = value;
      } else {
        this.importForm.codepay = null;
        this.importForm.codepayCode = null;
      }
    },
    onChangeImportCodeimportCode(event) {
      const value = event.target.value;
      const codeimports = this.importTypes.filter(
        item => item.codeimport === value
      );
      if (codeimports.length > 0) {
        this.importForm.codeimport = value;
      } else {
        this.importForm.codeimport = null;
        this.importForm.codeimportCode = null;
      }
    },
    onChangeSenderMfoCodefirmeCode(event) {
      const value = event.target.value;
      const codefirms = this.confirmSenderMfoForm.senders.filter(
        item => item.codefirme === value
      );
      if (codefirms.length > 0) {
        this.confirmSenderMfoForm.codefirme = value;
      } else {
        this.confirmSenderMfoForm.codefirme = null;
        this.confirmSenderMfoForm.codefirmeCode = null;
      }
    },
    onChangeSenderCodefirmeCode(event) {
      const value = event.target.value;
      const codefirms = this.params.gfirme.data.filter(
        item => item.codefirme === value
      );
      if (codefirms.length > 0) {
        this.confirmSenderForm.codefirme = value;
      } else {
        this.confirmSenderForm.codefirme = null;
        this.confirmSenderForm.codefirmeCode = null;
      }
    },
    onChangeConfirmDestLinkCode(event) {
      const value = event.target.value;
      const codeplat = this.params.codepay.data.filter(
        item => item.codeplat === value
      );
      if (codeplat.length > 0) {
        this.confirmDestLinkForm.codeplat = value;
      } else {
        this.confirmDestLinkForm.codeplat = null;
        this.confirmDestLinkForm.codeplatCode = null;
      }
    },
    onChangeSenderMfoNumberCode(event) {
      const value = event.target.value;
      const codefirms = this.confirmSenderMfoNumberForm.firms.filter(
        item => item.codefirme === value
      );
      if (codefirms.length > 0) {
        this.confirmSenderMfoNumberForm.codefirme = value;
      } else {
        this.confirmSenderMfoNumberForm.codefirme = null;
        this.confirmSenderMfoNumberForm.codefirmeCode = null;
      }
    },
    onShortKeyRouter(event) {
      switch (event.srcKey) {
        case "F2":
          // importModal: importModalReport
          if (this.importModal && this.reportBtnVisible) {
            this.importModalReport();
          }
          break;
        case "F3":
          // importModal: importModalSubmit
          if (this.importModal && this.importBtnVisible) {
            this.importModalSubmit();
          }
          break;
        case "Enter":
        case "F4":
        case "Star":
          // edit
          if (this.checkAllModal && !this.editBtnDisabled) {
            this.onEditBtn();
          }
          break;
        case "F7":
          // filterModal
          if (this.checkAllModal) {
            this.filterModal = true;
          }
          break;
        case "F8":
          // importModal: importpackpay
          if (
            this.checkAllModal &&
            this.params.importpack.importpackpay === "1"
          ) {
            this.onImportPaymentsBtn();
          }
          break;
        case "ShiftF8":
          // importModal: importpacksubs
          if (
            this.checkAllModal &&
            this.params.importpack.importpacksubs === "1"
          ) {
            this.onImportSubsidiesBtn();
          }
          break;
        case "F9":
          // posting
          // кнопка убрана из интерфейса, уточнение от 28.09.2021
          // if (this.checkAllModal && !this.postingBtnDisabled) {
          //   this.onPostingBtn();
          // }
          break;
        case "F10":
          // submit: filterModalSubmit
          if (this.filterModal) {
            this.filterModalSubmit();
          }
          // submit: editModalSubmit
          else if (this.editModal) {
            this.editModalSubmit();
          }
          // submit: uploadFilesSubmit
          else if (this.uploadFilesModal) {
            this.uploadFilesSubmit();
          }
          // submit: confirmDateBankModal
          else if (this.confirmDateBankModal) {
            this.confirmDateBankSubmit();
          }
          // submit: confirmSenderModal
          else if (this.confirmSenderModal) {
            this.confirmSenderSubmit();
          }
          // submit: confirmSenderMfoModal
          else if (this.confirmSenderMfoModal) {
            this.confirmSenderMfoSubmit();
          }
          // submit: confirmDestLinkModal
          else if (this.confirmDestLinkModal) {
            this.confirmDestLinkSubmit();
          }
          // submit: confirmSenderMfoNumberModal
          else if (this.confirmSenderMfoNumberModal) {
            this.confirmSenderMfoNumberSubmit();
          }
          break;
        case "Insert":
        case "Plus":
          // Add
          if (this.checkAllModal && !this.addBtnDisabled) {
            this.onAddBtn();
          }
          // Add: insertModalSubmit
          else if (this.editModal && this.statusModify === "add") {
            this.insertModalSubmit();
          }
          // Add Import File: importModal
          else if (this.importModal && !this.addImportFileBtnDisabled) {
            this.onAddImportFileBtn();
          }
          break;
        case "Del":
        case "Minus":
          // Storn
          if (this.checkAllModal && !this.deleteBtnDisabled) {
            this.onDeleteBtn();
          }
          // Del Import File: importModal
          else if (this.importModal && !this.deleteImportFileBtnDisabled) {
            this.onDeleteImportFileBtn();
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-button--primary {
  font-weight: 500 !important;
  color: rgb(49, 49, 78) !important;
  font-family: "Open Sans Bold", sans-serif !important;
}

.ag-header-icon .ag-header-cell-sorted-asc {
  color: green !important;
}
.moneydisable {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  &:hover {
    border-color: #e4e7ed;
  }
}

.grid-container-full {
  margin-top: 10px;
  height: calc(100vh - 175px);
  overflow-y: auto;
}

.grid-container-modal {
  height: calc(100vh - 250px);
  overflow-y: auto;
}

.grid-import-modal {
  height: calc(25vh);
  overflow-y: auto;
  margin-top: 20px;
}

.buttons-panel {
  margin-right: 5px;
}

.sender-filename {
  font-weight: bold;
}

.red-star {
  color: red;
  margin-right: 3px;
}

.hot-keys-pay {
  margin-left: 71px;
}

.hot-keys-sub {
  margin-left: 20px;
}
</style>
